<div class="chat-container">
  <div class="content-wrap">
    <!-- header start from here -->
    <div class="header">
      <img src="assets/LOGO.svg" class="logo-img" />
      <div class="userDetails" (click)="inbound()">
        <!-- <img src="assets/Hamburger.svg" class=""> -->
        <!-- inbound-call-location-code start -->
        <a href="tel:+919509044400" class="support-link" >
          <div class="support-button">
            Need Help?
            <img src="assets/images/dialNumber.svg" alt="" /> 9509044400
          </div>
        </a>
        <!-- inbound-call-location-code ends -->
      </div>
    </div>
    <!-- header end -->

  

    <div
      ngx-auto-scroll
      lock-y-offset="10"
      observe-attributes
      class="body-container"
    >
      <ul class="StepProgress">
        <li class="show-animation">
          <div class="timeLineMsg" *ngIf="!hidedivision && msgStepper_101">
            <div class="content">
              <p>Welcome to DMI Finance!</p>
            </div>
          </div>
        </li>

        <li class="show-animation" *ngIf="!hidedivision && msgStepper_102">
          <div class="timeLineMsg">
            <div class="content">
              <p>
                DMI Finance offers instant pre-approved personal loan up to Rs.
                10 lakhs at attractive rates.
              </p>
            </div>
          </div>
        </li>

        <li class="show-animation" *ngIf="!hidedivision && msgStepper_103">
          <div class="timeLineMsg">
            <div class="content">
              <p>Would you like to check your offer?</p>
            </div>
            <li class="show-animation1">
              <button
                class="reject1"
                (click)="onNoClick()"
                [hidden]="hidebutton"
              >
                No
              </button>
              <button class="accept1" (click)="onYes()" [hidden]="hidebutton">
                Yes
              </button>
            </li>
          </div>
        </li>

        <li class="show-animation" *ngIf="isYes && msgStepper_104">
          <div class="timeLineMsg-right1 left yes-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Yes</p>
              </div>
            </div>
          </div>
        </li>
        <li class="show-animation" *ngIf="isNo && msgStepper_108">
          <div class="timeLineMsg-right left yes-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>No</p>
              </div>
            </div>
          </div>
        </li>
        <li class="show-animation" *ngIf="isNo && msgStepper_109">
          <div class="timeLineMsg" style="margin-top: 70px">
            <div class="content">
              <p>Thank you for your time.</p>
              <p>
                You are welcome to call our Contact Center number
                <b>08064807777</b> in case you wish to know more.
              </p>
            </div>
          </div>
        </li>

        <li class="show-animation" *ngIf="isYes && msgStepper_105">
          <div
            class="timeLineMsg"
            style="margin-bottom: 20px; margin-top: 90px !important"
          >
            <img src="assets/sticker.png" class="status_img_height" />
          </div>
        </li>
        <li class="show-animation" *ngIf="isYes && msgStepper_106">
          <div class="timeLineMsg left-content-top-margin">
            <div class="content">
              <p>Great! Let's begin.</p>
            </div>
          </div>
        </li>

        <li
          class="show-animation"
          *ngIf="!afterVerifedOTP && isYes && msgStepper_107"
        >
          <div class="custom-card">
            <div (keyup.enter)="onSubmitMobile(1)">
              <mat-form-field class="width Inputfeild number_form">
                <input
                  type="number"
                  [readonly]="disableinput"
                  matInput
                  placeholder="Please enter your mobile number"
                  [(ngModel)]="mobileNumber"
                  maxlength="10"
                  appAutofocus
                  numbersOnly
                  required
                  onKeyPress="if(this.value.length == 10) return false;"
                  ng-readonly="disableinput==true"
                />
              </mat-form-field>

              <div *ngIf="wrongMobile">
                <p class="offernumber">Enter Valid Mobile Number.</p>
              </div>
              <div *ngIf="offernumber1">
                <p class="offernumber">{{ camp_details }}</p>
              </div>
              <div *ngIf="offernumber2">
                <p class="offernumber">
                  {{ camp_details }}
                </p>
              </div>
            </div>

            <div class="card-btn" *ngIf="!isYes1">
              <button (click)="onSubmitMobile(1)">Continue</button>
            </div>
            <li
              class="show-animation"
              *ngIf="!afterVerifedOTP && isYes && msgStepper_107 && showLoader"
            >
              <div class="timeLineMsg">
                <div class="" style="text-align: center !important">
                  <img src="assets/loading.gif" width="25" />
                </div>
              </div>
            </li>
            <p class="otp-font" *ngIf="otpOption">
              Enter the OTP sent to verify your mobile number {{ User_Mobile }}.
            </p>
            <div class="otp-section" *ngIf="otpOption">
              <ng-otp-input
                class="ngotp"
                *ngIf="showOtpSection && otpOption"
                #ngOtpInput
                (onInputChange)="onOtpChange($event)"
                [config]="config"
              ></ng-otp-input>
              <p *ngIf="showTimer" class="timer">
                Resend OTP in {{ timeLeft }}s
              </p>

              <div class="wrongOTP" *ngIf="resend_OTP && !showTimer">
                <a (click)="resendOTP()" style="cursor: pointer">Resend OTP</a>
                <p *ngIf="wrongOTP">{{ wrongOTP }}</p>
              </div>
            </div>
          </div>
        </li>

        <li
          class="show-animation"
          *ngIf="(afterVerifedOTP && msgStepper_112) || otpverified"
        >
          <div class="timeLineMsg-right left contact-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>{{ mobileNumber }}</p>
              </div>
            </div>
          </div>
        </li>

        <!-- <li class="show-animation" *ngIf="(afterVerifedOTP && msgStepper_111 && !userNotFound) || (otpverified)">
        <div class="timeLineMsg margin-top96">

            <div class="content">
                <p>Thank you for verifying your mobile number.</p>
                <p *ngIf="devicedialogopen">Please click "Allow" on the next screen to grant location access for the
                    loan application to continue.</p>
            </div>

        </div>
    </li> -->

        <div
          class="inner-loader"
          *ngIf="showofferLoader"
          style="text-align: center !important; margin-top: 10px"
        >
          <img src="assets/loading.gif" width="25" />
        </div>
        <!-- ---------------device track----------------------------- -->

        <!-- <li class="show-animation"
        *ngIf="(afterVerifedOTP && msgStepper_1121 && !userNotFound)||(otpverified && msgStepper_1121 && !userNotFound)">
        <div class="timeLineMsg" style="margin-bottom: 20px;margin-top: 30px !important;">
            <img src="assets/Location.svg" style="width: 110px;">
        </div>
    </li>
    <li class="show-animation"
        *ngIf="(afterVerifedOTP && msgStepper_112111 && !userNotFound) ||(otpverified && msgStepper_112111 && !userNotFound)">
        <div>

            <div class="content">
                <p>Please enable location tracking in order to proceed further.</p>
            </div>
            <div class="card-btn2">
                <button (click)="Retrylocation()" [hidden]="ishidden1">Retry</button>

            </div>
            <div class="content" *ngIf="Allowloaction" style="margin-top: 15px;">
                <p>Please allow location.</p>
            </div>
        </div>
    </li> -->

        <!-- Curing Emandate Integartion -->
        <div
          class="inner-loader"
          *ngIf="showcuringloader"
          style="text-align: center !important; margin-top: 100px"
        >
          <img src="assets/loading.gif" width="25" />
        </div>
        <div
          class="em_block margin-top45"
          style="margin-top: 100px !important"
          *ngIf="curing_emandate"
        >
          <li class="show-animation" *ngIf="curing_emandate">
            <div class="timeLineMsg">
              <div class="stepper-hr2"></div>
              <div class="content">
                <p>
                  Please re-submit your own bank details for us to process your
                  loan application.
                </p>
              </div>
            </div>
          </li>

          <li class="show-animation">
            <button
              (click)="kycModal(6)"
              type="button"
              [disabled]="isDisabled2 == true"
              [ngClass]="{ disabledClass: isDisabled2 == true }"
            >
              {{ emandateStatus }}
            </button>
          </li>

          <li
            class="show-animation margin-top15"
            *ngIf="rfcFailed && msgStepper_1010"
          >
            <div class="timeLineMsg-right left kyc-sec">
              <div class="alt-content1">
                <div class="happy-sec">
                  <p>Sorry!! the lender has rejected your application.</p>
                </div>
              </div>
            </div>
          </li>
        </div>
        <!-- Curing Remandate Success -->
        <li
          class="show-animation"
          *ngIf="iscuringEMandateCompleted && msgStepper_curing_904"
        >
          <div class="timeLineMsg-right left">
            <div class="alt-content1">
              <div
                class="happy-sec"
                *ngIf="iscuringEMandateCompleted && msgStepper_curing_904"
              >
                <p>E-Mandate registration is successful.</p>
              </div>
            </div>
          </div>
        </li>
        <!-- Curing Remandate Rejected -->
        <li
          class="show-animation margin-top15"
          *ngIf="!iscuringEMandateCompleted && msgStepper_curing_1010"
        >
          <div class="timeLineMsg-right left kyc-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Sorry!! the lender has rejected your application.</p>
              </div>
            </div>
          </div>
        </li>

        <!-- Curing Emandate Integartion -->

        <!-- ------------------------------------------------------------------?-- -->
        <!--  User's Mobile  does not exists in database -->

        <li class="show-animation" *ngIf="hideSection && msgStepper_108">
          <div class="timeLineMsg" style="margin-top: 50px">
            <div class="content">
              <p>
                Sorry, we do not have an offer associated with your mobile
                number.
              </p>
            </div>
          </div>
        </li>

        <li class="show-animation" *ngIf="hideSection && msgStepper_109">
          <div class="timeLineMsg" style="margin-top: 10px">
            <div class="stepper-hr2"></div>
            <div class="content">
              <p>Thank you for your time.</p>
              <p><img src="assets/images/logo.png" class="logo-img" /></p>
              <p>
                You are welcome to call our Contact Center number
                <b>08064807777</b> in case you wish to know more.
              </p>
            </div>
          </div>
        </li>

        <!-- PA Journey Start-->

        <div
          class="inner-loader"
          *ngIf="showcamploader"
          style="text-align: center !important; padding-bottom: 20px"
        >
          <img src="assets/loading.gif" width="25" />
        </div>
        <!--  Compilance changes 
       Richa Pathak 
       Date 9-01-2025 -->
        <li
          class="show-animation"
          *ngIf="
            (afterVerifedOTP && msgStepper_112 && !curing_journey) ||
            (otpverified && !curing_journey)
          "
        >
          <div class="timeLineMsg" style="margin-top: 90px">
            <div class="content">
              <p class="userNAme">
                Thank you for verifying your mobile number. Kindly accept the
                below terms and conditions in order to proceed.
              </p>
              <p class="userNAme">
                <small>
                  <ul style="margin-left: 20px; padding: 0px">
                    <li>
                      I agree that the loan applied from DMI Finance Private
                      Limited will be governed by the
                      <button
                        (click)="showLoanUndertaking()"
                        class="linkbutton1"
                      >
                        Loan Application Undertaking.
                      </button>
                    </li>
                    <li>
                      To process my application, I give my express consent to
                      DMI Finance for the below:<br />
                      - To obtain my credit report(s) from credit bureaus.<br />
                      - To fetch required information for KYC from approved
                      agencies including UIDAI.
                    </li>
                    <li>
                      To reach out to me with personalized offers on products &
                      services through SMS, WhatsApp, RCS, Email, and telephonic
                      calls/bots. This consent will override any registration
                      for DND and/or NDNC.
                    </li>
                  </ul>
                </small>
              </p>
              <button
                mat-button
                style="margin-bottom: 10px"
                (click)="onTermsAccept()"
                [ngClass]="{
                  disabledClass: istermsaccepted == true
                }"
                [disabled]="istermsaccepted"
              >
                Accept
              </button>
            </div>
          </div>
        </li>

        <li class="show-animation" *ngIf="msgStepper_0001 && istermsaccepted">
          <div class="timeLineMsg-right1 left yes-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Accepted</p>
              </div>
            </div>
          </div>
        </li>

        <!--Compilance changes End 
       Richa Pathak 
       Date 9-01-2025 -->

        <li class="show-animation" *ngIf="msgStepper_0001 && istermsaccepted">
          <div class="timeLineMsg" style="margin-top: 90px">
            <div class="content">
              <p class="userNAme">
                Thank you for accepting. Please tell us a bit about yourself.
              </p>

              <div class="content">
                <p>
                  What is your Employment Type?<br />
                  <br />
                  <mat-radio-group
                    aria-label="Select an option"
                    class="radio-text"
                    [(ngModel)]="emp_type"
                    (change)="onSelectmployement($event)"
                    [disabled]="is_Employement_submmited"
                    required
                  >
                    <mat-radio-button
                      color="primary"
                      value="Salaried"
                      class="alignment"
                      >Salaried <br />
                      <span class="dynamic-text"
                        ><small
                          >Receive a monthly salary from an organization</small
                        ></span
                      ></mat-radio-button
                    >
                    <mat-radio-button color="primary" value="Self-employed"
                      >Self-employed/Professional<br />
                      <span class="dynamic-text"
                        ><small
                          >Manage your own business or work as an independent
                          professional like doctor, CA</small
                        ></span
                      >
                    </mat-radio-button>
                    <mat-radio-button color="primary" value="Other"
                      >Other<br />
                      <span class="dynamic-text"
                        ><small
                          >Not affiliated with any organization, working as a
                          freelancer,contractual worker, or similar.</small
                        ></span
                      >
                    </mat-radio-button>
                  </mat-radio-group>
                </p>

                <button
                  mat-button
                  (click)="OnSubmitEmployement()"
                  [disabled]="is_Employement_submmited"
                  [ngClass]="{
                    disabledClass: is_Employement_submmited == true
                  }"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </li>

        <li
          class="show-animation"
          *ngIf="msgStepper_001 && is_Employement_submmited"
        >
          <div class="timeLineMsg-right1 left yes-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>{{ employment_type }}</p>
              </div>
            </div>
          </div>
        </li>

        <!--  Slary AMOUNT -->
        <li
          class="show-animation"
          style="margin-top: 100px"
          *ngIf="!curing_journey && is_Employement_submmited"
        >
          <div class="timeLineMsg" style="margin-top: 20px">
            <div class="content">
              <div class="content monthly-income">
                <h1 class="monthly-income-heading">
                  What is your total monthly income from all sources?<br />
                 <small>This may include salary, business income, property/rental
                  income, agricultural income,and any other sources.</small> <br />

                  <form [formGroup]="monthlyIncome">
                    <input
                      (keypress)="
                        ($event.charCode >= 48 && $event.charCode < 58)
                      "
                      type="number"                     
                      [readonly]="
                        is_transaction_mode_submitted &&
                        is_salary_amount_submitted
                      "
                      placeholder="Enter Here"
                      formControlName="salary"
                      maxlength="10"
                      ng-readonly="is_transaction_mode_submitted && is_salary_amount_submitted"
                    />
                 
                  <span class="error" *ngIf="showsalaryerror"
                  >Income should be greater than ₹1000</span
                >

                  <br />
                 
                  
                  How do you get your salary?

                  <br />

                  <mat-radio-group
                    aria-label="Select an option"
                    class="radio-text"
                    (change)="onSelecttransactionmode($event)"
                    [disabled]="
                      is_transaction_mode_submitted &&
                      is_salary_amount_submitted
                    "
                    formControlName="salary_mode"
                    required
                  >
                    <mat-radio-button color="primary" value="Online"
                      >Online</mat-radio-button
                    ><br />
                    <mat-radio-button color="primary" value="Cash"
                      >Cash</mat-radio-button
                    ><br />
                    <mat-radio-button color="primary" value="Cheque"
                      >Cheque</mat-radio-button
                    >
                  </mat-radio-group>
                  <br />
                </form>
                </h1>

                <button
                  mat-button
                  (click)="onSubmitTransactionMode()"
                  [disabled]="
                    is_transaction_mode_submitted && is_salary_amount_submitted
                  "
                  [ngClass]="{
                    disabledClass: salary != '' && is_transaction_mode_submitted
                  }"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </li>

        <ng-container>
          <li
            class="show-animation"
            *ngIf="
              msgStepper_002 &&
              is_transaction_mode_submitted &&
              is_salary_amount_submitted
            "
          >
            <div class="timeLineMsg-right1 left yes-sec">
              <div class="alt-content1">
                <div class="happy-sec">
                  <p>Salary details submitted</p>
                </div>
              </div>
            </div>
          </li>
        </ng-container>
        <!--Compilance changes End 
       Richa Pathak 
       Date 9-01-2025 -->
        <!-- monthly household screen -->
        <!--  Slary AMOUNT -->
        <li
          *ngIf="showHouseholdincome"
          class="show-animation"
          style="margin-top: 100px"
        >
          <div class="timeLineMsg" style="margin-top: 20px">
            <div class="content">
              <div class="content monthly-income">
                <h1 class="monthly-income-heading">
                  What is your monthly household income?
                  <br />
                  <small style="padding-top: 10px">
                    Household Income includes your individual income and the
                    income of all other members of your household (i.e. husband,
                    wife and unmarried children)
                  </small>
                  
<form [formGroup]="householdIncome"> 
  <input
  (keypress)="($event.charCode >= 48 && $event.charCode < 58)"
 type="number"
  
  [readonly]="isHouseholdincomesubmitted"
  placeholder="Enter Here"
  formControlName="householdincome"
  maxlength="10"
  ng-readonly="isHouseholdincomesubmitted"
/></form>
                 
          
                  
                  <span class="error" *ngIf="showerrormsg">{{ msg }}</span>
                  <br />
                
                </h1>
                
                </div></div>
      
                <button
                  mat-button
                  (click)="onSubmithousehold()"
                  [ngClass]="{
                    disabledClass: isHouseholdincomesubmitted
                  }"
                  [disabled]="isHouseholdincomesubmitted"
                >
                  Submit
                </button>
              </div>           
          
        </li>
        <!--  -->

        <li class="show-animation" *ngIf="isHouseholdincomesubmitted">
          <div class="timeLineMsg-right1 left yes-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Household income submitted</p>
              </div>
            </div>
          </div>
        </li>
        <div></div>

        <!-- offer rejection screen -->
        <li
          *ngIf="isHouseholdincomesubmitted"
          class="show-animation"
          style="margin-top: 100px"
        >
          <div
            *ngIf="isHouseholdincomesubmitted && !ishouseholdgreater"
            class="timeLineMsg"
            style="margin-top: 20px"
          >
            <div class="content">
              <div class="content">
                <img
                  style="width: 133px; height: 130px"
                  src="./assets//offer-rejection-screen.png"
                  alt=""
                />
                <p>
                  Sorry {{ lastname }}! We cannot offer you a loan at the
                  moment.
                </p>
                <p>
                  However, you can download the DMI Finance APP from the link
                  below to get a free Credit report or pay your Utility and
                  Mobile Bills with ease.
                </p>

                <button mat-button (click)="onSubmitGetDmiFinanceApp()">
                  Get DMI Finance APP
                </button>
              </div>
            </div>
          </div>
        </li>

        <!-- Compilance changes End  -->
        <!-- Richa Pathak  -->
        <!-- Date 9-01-2025 -->
        <!-- Loan Amount  -->

        <li
          class="show-animation"
          style="margin-top: 100px"
          *ngIf="
            (msgStepper_002 &&
              is_transaction_mode_submitted &&
              is_salary_amount_submitted &&
              !curing_journey &&
              !showHouseholdincome) ||
            (isHouseholdincomesubmitted && ishouseholdgreater && msg_1008)
          "
        >
          <div class="timeLineMsg" style="margin-top: 20px">
            <div class="content">
              <div class="content">
                <p>
                  What is the purpose of your loan?<br /><br />
                  <mat-radio-group
                    aria-label="Select an option"
                    class="radio-text"
                    [(ngModel)]="purspose"
                    (change)="onSelectloanpurpose($event)"
                    [disabled]="is_loan_purpose && is_loan_amount"
                    required
                  >
                    <mat-radio-button color="primary" value="Wedding/Event"
                      >Wedding/Event</mat-radio-button
                    ><br />
                    <mat-radio-button color="primary" value="Home Renovation"
                      >Home Renovation</mat-radio-button
                    ><br />
                    <mat-radio-button
                      color="primary"
                      value="Business Requirement"
                      >Business Requirement</mat-radio-button
                    ><br />
                    <mat-radio-button color="primary" value="Education"
                      >Education</mat-radio-button
                    ><br />
                    <mat-radio-button color="primary" value="Medical Emergency"
                      >Medical Emergency</mat-radio-button
                    ><br />
                    <mat-radio-button color="primary" value="Travel"
                      >Travel</mat-radio-button
                    ><br />
                    <mat-radio-button
                      color="primary"
                      value="Repayment of other Loan"
                      >Repayment of other Loan</mat-radio-button
                    ><br />
                    <mat-radio-button color="primary" value="Personal Use"
                      >Personal Use</mat-radio-button
                    ><br />
                    <mat-radio-button color="primary" value="Other"
                      >Other</mat-radio-button
                    ><br />
                  </mat-radio-group>
                  <mat-form-field
                    class="width Inputfeild number_form"
                    *ngIf="loan_purspose == 'Other'"
                  >
                    <input
                      type="text"
                      [readonly]="disablesalaryinput"
                      matInput
                      placeholder="Enter Here"
                      [(ngModel)]="required_loan"
                      maxlength="80"
                      appAutofocus
                      numbersOnly
                      required
                      onKeyPress="if(this.value.length == 80) return false;"
                      ng-readonly="disablesalaryinput==true"
                    />
                  </mat-form-field>
                </p>

                <button
                  mat-button
                  (click)="OnSubmitRequiredLoanamount()"
                  [disabled]="is_loan_purpose && is_loan_amount"
                  [ngClass]="{
                    disabledClass: is_loan_purpose && is_loan_amount
                  }"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </li>
        <li
          class="show-animation"
          *ngIf="msgStepper_003 && is_loan_purpose && is_loan_amount"
        >
          <div class="timeLineMsg-right1 left yes-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Loan details submitted</p>
              </div>
            </div>
          </div>
        </li>
        <!-- Loan Amount -->

        <!-- PA Journey End -->

        <div
          class="inner-loader"
          *ngIf="showcamploader"
          style="text-align: center !important; padding-bottom: 20px"
        >
          <img src="assets/loading.gif" width="25" />
        </div>
        <li
          class="show-animation"
          *ngIf="
            msgStepper_003 && is_loan_purpose && is_loan_amount && !showTopupOffer
      "
        >
          <div class="timeLineMsg" style="margin-top: 100px">
            <div class="content">
              <p class="userNAme">Hello {{f_name}} {{l_name}}!</p>
              <p class="description" mat-dialog-title>
                We have a pre-approved loan offer for you.
              </p>
            </div>
          </div>
        </li>
        <li
          class="show-animation for_custom_label"
          *ngIf="
            msgStepper_003 && is_loan_purpose && is_loan_amount && !showTopupOffer"
        >
          <div class="container">
            <!-- <div class="main_page animation">
                <div class="animated_gif">
                    <img src="assets/giftbox.gif" alt="" height="200px" style="margin-top: 6px;">
                </div>
                <p style="text-align: center;font-size: 14px;margin-right: 20px;margin-top: 0px !important;">Loan Amount
                </p>
                <p style="text-align: center; font-size: 30px;margin-top: 5px;margin-right: 20px;margin-bottom: 45px;">
                    &#8377; {{offerAmount | inrFormat}}</p>

                <p>Loan Tenor <span class="dash_line"></span><span class="loan">{{offertenor}} Months</span></p>
                <p>Rate of Interest* <span class="dash_line"></span><span class="loan">{{offerroi}}</span></p>
                <p>EMI <span class="dash_line"></span><span class="loan">&#8377; {{offeremi | inrFormat}}</span></p>
                <p style="margin-bottom:20px; font-size: 12px !important;">*Calculated on an annualised interest rate of
                    {{ROIAnnually}}% on reducing balance.</p>
            </div> -->
            <div class="offer-flexibility">
              <div *ngIf="OfferAccepted; else elseblock">
                <div class="amount-moneyPNG">
                  <div>
                    <p class="select-loan-amount">SELECT LOAN AMOUNT</p>
                    <p class="nmbr-select-amount">
                      ₹{{ gridSize.value | inrFormat }}
                    </p>
                  </div>
                  <div>
                    <img
                      src="assets/images/money.png"
                      alt=""
                      height="58px"
                      width="87px"
                    />
                  </div>
                </div>
                <p class="txt-loan-amount">
                  Move the slider to select your loan amount.
                </p>
                <div class="slider">
                  <div class="min-max-amount">
                    <p class="slider-amount" id="min-value">
                      Min ₹{{ min | inrFormat }}
                    </p>
                    <p class="slider-amount" id="max-value">
                      Max ₹{{ max | inrFormat }}
                    </p>
                  </div>
                  <mat-slider
                    thumbLabel
                    id="slider"
                    step="{{ stepup }}"
                    #gridSize
                    (change)="updateSetting(gridSize.value)"
                    min="{{ min }}"
                    max="{{ max }}"
                    value="{{ gridsize }}"
                    class="cdk-focused"
                    style="padding: 0px; margin-top: -25px"
                  >
                  </mat-slider>
                </div>
                <div class="tenure-container">
                  <label class="labels">SELECT EMI</label>
                  <div *ngIf="tenorOptions.length > 0">
                    <div *ngFor="let tenor of tenorOptions; index as i">
                      <div
                        class="tenure-text-container"
                        (click)="selectItem(i)"
                        [ngStyle]="{
                          background:
                            selectedId === i ||
                            (selectedId === -1 && i === tenorOptions.length - 1)
                              ? 'linear-gradient(265.5deg, #4088EB -11.42%, #6FCEF3 94.93%)'
                              : 'none',
                          'z-index':
                            selectedId === i ||
                            (selectedId === -1 && i === tenorOptions.length - 1)
                              ? 2
                              : 'auto'
                        }"
                      >
                        <input
                          type="radio"
                          style="display: none"
                          [id]="tenor"
                          name="offerOption"
                          [value]="tenor"
                        />
                        <div class="button-option">
                          <div class="dynamic-months">{{ tenor }} Months</div>
                          <div class="dynamic-emi-amount">
                            <span class="dynamic-emi"
                              >₹{{ emi[i] | inrFormat }} EMI</span
                            >
                            <span class="dynamic-interest"
                              >(interest ₹{{ interest[i] | inrFormat }})</span
                            >
                          </div>
                        </div>
                      </div>
                      <div *ngIf="i === 0" class="label-recommended">
                        <span class="recommended">Recommended</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #elseblock>
                <div class="amount-moneyPNG">
                  <div>
                    <p class="select-loan-amount">SELECTED LOAN AMOUNT</p>
                    <p class="nmbr-select-amount">
                      ₹{{ ResumeAmount | inrFormat }}
                    </p>
                  </div>
                  <div>
                    <img
                      src="assets/images/money.png"
                      alt=""
                      height="58px"
                      width="87px"
                    />
                  </div>
                </div>
                <div class="slider">
                  <mat-slider
                    thumbLabel
                    id="slider"
                    step="{{ stepup }}"
                    #gridSize
                    (change)="updateSetting(gridSize.value)"
                    min="{{ min }}"
                    max="{{ max }}"
                    value="{{ ResumeAmount }}"
                    class="cdk-focused"
                    style="padding: 0px; margin-top: -25px"
                    [disabled]="!OfferAccepted"
                  >
                  </mat-slider>
                  <!-- <input type="range" id="slider"  step={{0}} #gridSize min={{min}} max={{max}} value={{ResumeAmount}} [disabled] = "!OfferAccepted"> -->
                  <div class="min-max-amount">
                    <p class="slider-amount" id="min-value">
                      Min ₹{{ min | inrFormat }}
                    </p>
                    <p class="slider-amount" id="max-value">
                      Max ₹{{ max | inrFormat }}
                    </p>
                  </div>
                </div>
                <div class="tenure-container">
                  <label class="labels">SELECTED EMI</label>
                  <div>
                    <div
                      class="tenure-text-container"
                      [ngStyle]="{
                        background:
                          'linear-gradient(265.5deg, #4088EB -11.42%, #6FCEF3 94.93%)'
                      }"
                    >
                      <input
                        type="radio"
                        style="display: none"
                        [id]="tenor"
                        name="offerOption"
                        [value]="tenor"
                      />
                      <div class="button-option">
                        <div class="dynamic-months">
                          {{ ResumeTenor | inrFormat }} Months
                        </div>
                        <div class="dynamic-emi-amount">
                          <span class="dynamic-emi"
                            >₹{{ ResumeEMI | inrFormat }} EMI</span
                          >
                          <span class="dynamic-interest"
                            >(interest ₹{{ ResumeInterest | inrFormat }})</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <div>
                <span class="rate-of-interest"
                  >Rate of Interest - {{ interestRate }}% per month [Calculated
                  on an annualised interest rate of {{ offeredInterest }}% on
                  reducing balance]</span
                >
              </div>
            </div>

            <div
              class="inner-loader"
              *ngIf="showLoader1 || resumeloader"
              style="text-align: center !important"
            >
              <img src="assets/loading.gif" width="25" />
            </div>
          </div>
          <div class="card-btn" [hidden]="hidediv" style="padding-top: 40px">
            <button class="reject" (click)="offerDenied()">
              Not Interested
            </button>
            <button class="accept" (click)="loanOfferSubmit()">
              Interested
            </button>
          </div>
        </li>

        <!-- top up offer  -->

        <li
          class="show-animation"
          style="margin-top: 100px"
          *ngIf="
            (msgStepper_003 &&
              is_loan_purpose &&
              is_loan_amount &&
              showTopupOffer &&
              !curing_journey) ||
            (showTopupOffer &&
              msgStepper_003 &&
              is_loan_purpose &&
              is_loan_amount &&
              !curing_journey)
          "
        >
          <div class="timeLineMsg" style="margin-top: 20px">
            <div class="content">
              <p class="userNAme">Hello {{f_name}} {{l_name}}!</p>
              <p class="description" mat-dialog-title>
                We have a pre-approved top up loan offer for you.
              </p>
            </div>
          </div>
        </li>

        <div
          class="main__container"
          *ngIf="
            (msgStepper_003 &&
              is_loan_purpose &&
              is_loan_amount &&
              showTopupOffer &&
              !curing_journey) ||
            (showTopupOffer &&
              msgStepper_003 &&
              is_loan_purpose &&
              is_loan_amount &&
              !curing_journey)
          "
        >
          <div class="container_topup">
            <div class="coontainer__top">
              <div class="loan__details">
                <p>Existing Loan Details</p>
              </div>
              <div class="loan__details__bottom">
                <div class="Inner_content_topup">
                  <p>Sanctioned</p>
                  <p>Amount</p>
                  <p>₹{{ sanctionamount1 }}</p>
                </div>

                <div class="Inner_content_topup">
                  <p>Total</p>
                  <p>Outstanding</p>
                  <p>₹ {{ outstanding1 }}</p>
                </div>

                <div class="Inner_content_topup">
                  <p>Ongoing</p>
                  <p>EMI</p>
                  <p>₹ {{ current_emi1 }}</p>
                </div>
              </div>
            </div>

            <div class="container-middle">
              <div class="inner__content_middle">
                <p>You are eligible for a total loan amount of</p>
                <h3>₹ {{ offerAmount1 }}</h3>
                <p>(This includes your existing outstanding loan amount)</p>
              </div>
            </div>
            <div class="inner__content_middle_sub">
              <svg
                width="20"
                height="20"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.5 2.5H5.5V3.5H4.5V2.5ZM4.5 4.5H5.5V7.5H4.5V4.5ZM5 0C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10C7.76 10 10 7.76 10 5C10 2.24 7.76 0 5 0ZM5 9C2.795 9 1 7.205 1 5C1 2.795 2.795 1 5 1C7.205 1 9 2.795 9 5C9 7.205 7.205 9 5 9Z"
                  fill="#1066AD"
                />
              </svg>

              <p>
                Your existing loan will be closed and a new loan with Total
                Amount will be sanctioned.
              </p>
            </div>

            <div class="inner__bottom">
              <div class="inner__botton__content">
                <p>Please refer details below.</p>

                <div class="inner__bottom_details">
                  <p>Total Loan Amount (A)</p>
                  <p>₹ {{ offerAmount1 }}</p>
                </div>

                <div class="inner__bottom_details">
                  <p>Total Outstanding (B)</p>
                  <p>₹ {{ outstanding1 }}</p>
                </div>

                <div class="inner__bottom_details">
                  <p>Top-up Loan Amount (A - B)</p>
                  <p>₹ {{ topupamount1 }}</p>
                </div>

                <div class="inner__bottom_details">
                  <p>
                    Processing fee <span class="changecolor">(Incl. GST)</span>
                  </p>
                  <p>₹ {{ processing_fee1 }}</p>
                </div>

                <div class="inner__bottom_details">
                  <p>Net Disbursal Amount</p>
                  <p>₹ {{ disburseamount1 }}</p>
                </div>

                <div class="inner__bottom_details">
                  <p>Loan Tenor</p>
                  <p>{{ offertenor }} months</p>
                </div>

                <div class="inner__bottom_details">
                  <p>Interest Rate</p>
                  <p>{{ offerroi }}</p>
                </div>

                <div class="inner__bottom_details">
                  <p>New EMI</p>
                  <p>₹ {{ offeremi1 }} p.m.</p>
                </div>
              </div>

              <div class="bottom-text">
                <p>
                  *Calculated on an annualized interest rate of
                  {{ ROIAnnually }}% on reducing balance.
                </p>
              </div>

              <div class="inner_bottom__buttons" [hidden]="hidediv">
                <div class="button__one">
                  <button (click)="offerDenied()" [hidden]="ishidden1">
                    Not-interested
                  </button>
                </div>

                <div class="button__two">
                  <button (click)="loanOfferSubmit()" [hidden]="ishidden2">
                    Interested
                  </button>
                </div>
              </div>
              <div
                class="inner-loader"
                *ngIf="showLoader1 || resumeloader"
                style="text-align: center !important"
              >
                <img src="assets/loading.gif" width="25" />
              </div>
            </div>
          </div>
        </div>

        <li
          class="show-animation"
          *ngIf="showerror && msgStepper_15 && !showLoader1"
        >
          <div class="timeLineMsg" style="margin-top: 40px !important">
            <div class="stepper-hr2"></div>
            <div class="content">
              <p>Something went wrong.</p>
              <p>Please try again after some time.</p>
            </div>
          </div>
        </li>
        <li class="show-animation margin-top15" *ngIf="counter && msg100">
          <div class="left kyc-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Sorry!! the lender has rejected your application.</p>
              </div>
            </div>
          </div>
        </li>
        <li class="show-animation" *ngIf="counter && msg101">
          <div class="" style="margin-top: 120px !important">
            <div class="stepper-hr2"></div>
            <div class="content">
              <p>Thank you for your time.</p>
              <p>
                You are welcome to call our Contact Center number
                <b>08064807777</b> in case you wish to know more.
              </p>
            </div>
          </div>
        </li>
        <li class="show-animation" *ngIf="offererror">
          <div class="" style="margin-top: 20px !important">
            <div class="stepper-hr2"></div>
            <div class="content">
              <p>{{ ErrorMessage }}</p>
            </div>
          </div>
        </li>
        <!-- Case 3: User denied Loan Offer  -->

        <li class="show-animation" *ngIf="offerdenied && msgStepper_112">
          <div class="timeLineMsg-right left contact-sec">
            <div class="alt-content11">
              <div class="happy-sec">
                <p>You have rejected the loan offer.</p>
              </div>
            </div>
          </div>
        </li>
        <li class="show-animation" *ngIf="offerdenied && msg_107">
          <div class="timeLineMsg" style="margin-top: 100px">
            <div class="content">
              <p>Select your reason for rejection.</p>
            </div>

            <br />
            <form class="example-form" [formGroup]="reasonForm">
              <mat-radio-group
                aria-label="Select an option"
                class="radio-text"
                formControlName="reason"
                required
              >
                <mat-radio-button color="primary" value="Amount is too low"
                  >Amount is too low</mat-radio-button
                >
                <mat-radio-button
                  color="primary"
                  value="Interest rate not acceptable"
                  >Interest rate not acceptable
                </mat-radio-button>
                <mat-radio-button
                  color="primary"
                  value="Tenor is too long / short"
                  >Tenor is too long/short
                </mat-radio-button>
                <mat-radio-button
                  color="primary"
                  value="Availed from other lender"
                  >Availed from other lender
                </mat-radio-button>
                <mat-radio-button
                  color="primary"
                  value="Poor experience with DMI"
                  >Poor experience with DMI </mat-radio-button
                ><br />
                <mat-radio-button color="primary" value="Other"
                  >Other</mat-radio-button
                > </mat-radio-group
              ><br />
              <button
                mat-button
                (click)="thankuforVisit()"
                [disabled]="reasonForm.invalid"
                [hidden]="hideofferinterest"
              >
                Submit
              </button>
            </form>
            <div
              class="inner-loader"
              *ngIf="offerrejection"
              style="text-align: center !important; padding-bottom: 20px"
            >
              <img src="assets/loading.gif" width="25" />
            </div>
          </div>
        </li>

        <li class="show-animation" *ngIf="exitjourney && msg_107">
          <div class="timeLineMsg-right left contact-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>{{ Denial_reason }}</p>
              </div>
            </div>
          </div>
        </li>

        <li class="show-animation" *ngIf="exitjourney && msg_107">
          <div class="timeLineMsg" style="margin-top: 100px">
            <div class="content">
              <p>Thank you for your time</p>
              <p><img src="assets/images/logo.png" class="logo-img" /></p>
              <p>
                You are welcome to call our Contact Center number
                <b>08064807777</b> in case you wish to know more.
              </p>
            </div>
          </div>
        </li>

        <!-- Case:4 :Kyc Flag true -->

        <li
          class="show-animation"
          *ngIf="
            (offeraccepted &&
              msg6 &&
              !kyc_flag &&
              !showLoader1 &&
              !counter &&
              !tryagain1) ||
            (offeraccepted &&
              msg6 &&
              kyc_flag &&
              !showLoader1 &&
              !counter &&
              !tryagain1) ||
            (resumekyc && msg8)
          "
        >
          <div class="timeLineMsg-right1 left yes-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Interested</p>
              </div>
            </div>
          </div>
        </li>

        <li
          class="show-animation"
          *ngIf="
            (offeraccepted &&
              msg6 &&
              !kyc_flag &&
              !showLoader1 &&
              !counter &&
              !tryagain1) ||
            (offeraccepted &&
              msg6 &&
              kyc_flag &&
              !showLoader1 &&
              !counter &&
              !tryagain1) ||
            (resumekyc && msg8)
          "
          style="margin-top: 80px"
        >
          <div class="content">
            <p>Thank you for accepting the offer.</p>
            <div
              class="timeLineMsg"
              style="margin-bottom: 20px; margin-top: 30px !important"
              *ngIf="devicedialogopen"
            >
              <img
                src="assets/Location.png"
                style="width: 50px; height: 50px"
              />
            </div>

            <p *ngIf="devicedialogopen">
              Please click "Allow" on the next screen to grant location access
              for the loan application to continue.
            </p>
          </div>
        </li>

        <!-- Location steps integration -->
        <!-- Richa  -->
        <!-- 2-01-2025 -->

        <li
          class="show-animation"
          style="margin-top: 20px"
          *ngIf="
            (offeraccepted &&
              msg6 &&
              !kyc_flag &&
              !showLoader1 &&
              !counter &&
              !tryagain1 &&
              !isenable &&
              !devicedialogopen) ||
            (offeraccepted &&
              msg6 &&
              kyc_flag &&
              !showLoader1 &&
              !counter &&
              !tryagain1 &&
              !isenable) ||
            (resumekyc && msg8 && !isenable && !devicedialogopen)
          "
        >
          <div>
            <div class="timeLineMsg-right1 left yes-sec">
              <div class="alt-content1">
                <div class="happy-sec-1">
                  <p>Location not enabled</p>
                </div>
              </div>
            </div>
          </div>
        </li>

        <li
          class="show-animation"
          style="margin-top: 100px"
          *ngIf="
            (offeraccepted &&
              msg6 &&
              !kyc_flag &&
              !showLoader1 &&
              !counter &&
              !tryagain1 &&
              !isenable &&
              !devicedialogopen) ||
            (offeraccepted &&
              msg6 &&
              kyc_flag &&
              !showLoader1 &&
              !counter &&
              !tryagain1 &&
              !isenable) ||
            (resumekyc && msg8 && !isenable && !devicedialogopen)
          "
        >
          <div>
            <div class="content">
              <p>
                Please enable location tracking in order to proceed further.
              </p>
            </div>
            <div class="content">
              <!-- Location steps integration -->
              <!-- Richa  -->
              <!-- 2-01-2025 -->
              <p>
                <video
                  controls
                  autoplay
                  loop
                  muted
                  width="200"
                  height="200"
                  poster="thumbnail.jpg"
                >
                  <source [src]="videourl" class="video_css" type="video/mp4" />
                  <source src="" type="video/ogg" />
                  Your browser does not support the video tag.
                </video>
              </p>

              <div class="content">
                <p>Watch how to allow location access!</p>
              </div>

              <button (click)="Retrylocation()" [hidden]="ishidden1">
                Retry
              </button>
            </div>
            <div class="content" *ngIf="Allowloaction" style="margin-top: 15px">
              <p>Please allow location.</p>       
            </div>
          </div>
        </li>
        <div
          class="kyc_block"
          *ngIf="
            (kyc_flag &&
              msg9 &&
              !showLoader1 &&
              offeraccepted &&
              !counter &&
              !tryagain1 &&
              isenable) ||
            (resumekyc && msg9 && isenable)
          "
        >
          <li
            class="show-animation"
            *ngIf="
              (kyc_flag &&
                msg9 &&
                !showLoader1 &&
                offeraccepted &&
                !counter &&
                !tryagain1 &&
                isenable) ||
              (resumekyc && msg9 && isenable)
            "
          >
            <div class="timeLineMsg" style="margin-top: 20px">
              <div class="stepper-hr2"></div>
              <div class="content">
                <p>Please complete your KYC.</p>
                <P>You are just a few steps away.</P>
                <p *ngIf="isretry">
                  Oops! That was an unclear picture. Kindly click and send a new
                  one.
                </p>
              </div>
            </div>
          </li>
          <li
            class="show-animation"
            *ngIf="
              (!isKYCSuccess &&
                kyc_flag &&
                msg9 &&
                !showLoader &&
                offeraccepted &&
                !counter) ||
              (resumekyc && msg9)
            "
          >
            <button
              (click)="kycModal(1)"
              [disabled]="isDisabled == true"
              type="button"
              [ngClass]="{ disabledClass: isDisabled == true }"
              [hidden]="hide1"
            >
              Proceed
            </button>
          </li>
          <li
            class="show-animation margin-top15"
            *ngIf="(!isKYCSuccess && msg_61) || (counter && msg100)"
          >
            <div class="timeLineMsg-right left kyc-sec">
              <div class="alt-content1">
                <div class="happy-sec">
                  <p>Sorry!! the lender has rejected your application.</p>
                </div>
              </div>
            </div>
          </li>
          <li
            class="show-animation"
            *ngIf="(!isKYCSuccess && msgStepper_62) || (counter && msg101)"
          >
            <div class="timeLineMsg" style="margin-top: 120px !important">
              <div class="stepper-hr2"></div>
              <div class="content">
                <p>Thank you for your time.</p>
                <p>
                  You are welcome to call our Contact Center number
                  <b>08064807777</b> in case you wish to know more.
                </p>
              </div>
            </div>
          </li>

          <li
            class="show-animation margin-top15"
            *ngIf="isKYCSuccess && msgStepper_403"
          >
            <div class="timeLineMsg-right left kyc-sec">
              <div class="alt-content1">
                <div class="happy-sec">
                  <p>KYC</p>
                </div>
              </div>
            </div>
          </li>

          <li class="show-animation" *ngIf="isKYCSuccess && msgStepper_404">
            <div
              class="left-allign margin-top96"
              style="margin-top: 30px; margin-left: -10px"
            >
              <img
                src="assets/new-icons/afterKyc.png"
                class="status_img_height"
              />
            </div>
          </li>

          <li class="show-animation" *ngIf="isKYCSuccess && msgStepper_405">
            <div>
              <div class="stepper-hr2"></div>
              <div class="content">
                <p>Thank you for completing your KYC.</p>
              </div>
            </div>
          </li>
        </div>

        <!-- Kyc Flag false  -->
        <div
          *ngIf="
            (!kyc_flag &&
              offeraccepted &&
              !showLoader1 &&
              msg5 &&
              !counter &&
              !tryagain1 &&
              isenable) ||
            (kycaddress && isenable)
          "
        >
          <li class="show-animation">
            <div class="timeLineMsg" style="margin-top: 20px">
              <div class="stepper-hr1"></div>
              <div class="content msg_dialog">
                <p class="description" mat-dialog-title>
                  Please confirm your KYC details available with us.
                </p>
                <br />
              </div>
            </div>
          </li>

          <li
            class="show-animation for_custom_label"
            *ngIf="
              (!kyc_flag &&
                offeraccepted &&
                !showLoader1 &&
                msg6 &&
                !counter &&
                !tryagain1 &&
                isenable) ||
              (resume_selfie && msg6 && isenable) ||
              (kycaddress && isenable)
            "
          >
            <div class="container1">
              <h1 class="Kyc_details">KYC Details</h1>

              <div class="main_page1 animation">
                <p>
                  <span class="kyc-details">Name:</span>
                  <span class="Span"
                    ><b>{{ firstname }} {{ lastname }}</b></span
                  >
                </p>

                <p>
                  <span class="kyc-details">DOB:</span>
                  <span class="Span"
                    ><b>{{ dob }}</b></span
                  >
                </p>
                <p>
                  <span class="kyc-details">Address:</span
                  ><span class="Span"
                    ><b>{{ MailingStreet }}</b></span
                  >
                </p>
                <p>
                  <span class="kyc-details">Pin Code:</span>
                  <span class="Span"
                    ><b>{{ MailingPostalCode }}</b></span
                  >
                </p>
                <p>
                  <span class="kyc-details">City: </span
                  ><span class="Span"
                    ><b>{{ MailingCity }}</b></span
                  >
                </p>
                <p>
                  <span class="kyc-details">State:</span>
                  <span class="Span"
                    ><b>{{ MailingState }}</b></span
                  >
                </p>
                <p>
                  <span class="kyc-details">Country: </span
                  ><span class="Span"
                    ><b>{{ MailingCountry }}</b></span
                  >
                </p>
              </div>
              <div class="card-btn" [hidden]="disablebutton">
                <button
                  class="reject"
                  (click)="repeatekyc()"
                  [hidden]="hideaddress"
                >
                  No
                </button>
                <button
                  class="accept"
                  (click)="checkadressflag()"
                  [hidden]="hideaddress"
                >
                  Yes
                </button>
              </div>

              <div class="inner-loader" *ngIf="">
                <img src="assets/loading.gif" width="25" />
              </div>
            </div>
          </li>
        </div>

        <li
          class="show-animation margin-top15"
          *ngIf="!addressrequired && msgStepper_34 && isenable"
        >
          <div class="timeLineMsg-right left kyc-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Thank you for confirming the KYC</p>
              </div>
            </div>
          </div>
        </li>

        <li
          class="show-animation margin-top15"
          *ngIf="isrepeateKyc && msgStepper_30 && isenable"
        >
          <div class="timeLineMsg-right left kyc-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>NO</p>
              </div>
            </div>
          </div>
        </li>

        <li *ngIf="isrepeateKyc && msgStepper_30 && isenable">
          <div class="timeLineMsg" style="margin-top: 100px">
            <div class="stepper-hr2"></div>
            <div class="content">
              <p>Please complete your KYC.</p>
              <P>You are just a few steps away.</P>
              <p *ngIf="isretry">
                Oops! That was an unclear picture. Kindly click and send a new
                one.
              </p>
            </div>
          </div>
        </li>
        <li
          class="show-animation"
          *ngIf="isrepeateKyc && msgStepper_32 && isenable"
        >
          <button
            (click)="kycModal(1)"
            [disabled]="isDisabled == true"
            type="button"
            [ngClass]="{ disabledClass: isDisabled == true }"
          >
            {{ kycStatus }}
          </button>
        </li>
        <li
          class="show-animation margin-top15"
          *ngIf="!isKYCSuccess && isrepeateKyc && msg_61 && isenable"
        >
          <div class="timeLineMsg-right left kyc-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Sorry!! the lender has rejected your application.</p>
              </div>
            </div>
          </div>
        </li>
        <li
          class="show-animation"
          *ngIf="!isKYCSuccess && isrepeateKyc && msgStepper_62 && isenable"
        >
          <div class="timeLineMsg" style="margin-top: 120px !important">
            <div class="stepper-hr2"></div>
            <div class="content">
              <p>Thank you for your time.</p>
              <p>
                You are welcome to call our Contact Center number
                <b>08064807777</b> in case you wish to know more.
              </p>
            </div>
          </div>
        </li>
        <li
          class="show-animation margin-top15"
          *ngIf="isKYCSuccess && msgStepper_403 && isrepeateKyc && isenable"
        >
          <div class="timeLineMsg-right left kyc-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>KYC</p>
              </div>
            </div>
          </div>
        </li>
        <li
          class="show-animation"
          *ngIf="tryagain1 && msgStepper_1000 && !isKYCSuccess && isenable"
        >
          <div class="timeLineMsg" style="margin-top: 40px !important">
            <div class="stepper-hr2"></div>
            <div class="content">
              <p>Something went wrong.</p>
              <p>Please try again after some time.</p>
            </div>
          </div>
        </li>

        <li
          class="show-animation"
          *ngIf="isKYCSuccess && msgStepper_404 && isrepeateKyc && isenable"
        >
          <div
            class="timeLineMsg left-allign margin-top96"
            style="margin-top: 30px"
          >
            <img
              src="assets/new-icons/afterKyc.png"
              class="status_img_height"
            />
          </div>
        </li>

        <li
          class="show-animation"
          *ngIf="isKYCSuccess && msgStepper_405 && isrepeateKyc && isenable"
        >
          <div class="timeLineMsg">
            <div class="stepper-hr2"></div>
            <div class="content">
              <p>Thank you for completing your KYC.</p>
            </div>
          </div>
        </li>

        <!-- Update Communication -->

        <li
          class="show-animation"
          *ngIf="isKYCSuccess && msgStepper_501 && isenable"
        >
          <div>
            <div class="stepper-hr1"></div>
            <div class="content">
              <p>Please confirm/edit your current address.</p>
            </div>
          </div>
        </li>

        <li
          class=""
          *ngIf="
            (isKYCSuccess && msgStepper_506 && isenable) || (step2 && isenable)
          "
        >
          <div class="custom-card" [hidden]="ishiddencom">
            <h4>Current Address</h4>
            <P style="color: red; font-weight: 400; max-width: 100%;overflow-wrap: break-word;">Please provide your correct residential address, as it may be verified before loan disbursal.</P>
            <form [formGroup]="residenceForm">
              <ng-container>
                <mat-form-field class="width">
                  <mat-label
                    >Flat No/ House No/ Plot No/ Building Name</mat-label
                  >
                  <input matInput formControlName="flat" required />
                </mat-form-field>

                <mat-form-field class="width">
                  <mat-label>Cross/ Lane/ Locality/ Area/ Landmark</mat-label>
                  <input matInput formControlName="landmark" required />
                </mat-form-field>
                <mat-form-field class="width">
                  <mat-label>Village/ Town / City / Post Office </mat-label>
                  <input matInput formControlName="postOffice" required />
                </mat-form-field>
                <mat-form-field class="width">
                  <mat-label>Pin Code*</mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="Pincode"
                    (ngModelChange)="onpinchange($event)"
                    onKeyPress="if(this.value.length==6) return false;"
                  />
                </mat-form-field>
                <div class="error" *ngIf="wrongMobile1">
                  {{ requiredMsg }}
                </div>

                <mat-form-field class="width">
                  <mat-label>District</mat-label>
                  <input matInput formControlName="District" required />
                </mat-form-field>

                <mat-form-field class="width">
                  <mat-label>State</mat-label>

                  <mat-select formControlName="State" required>
                    <mat-option
                      *ngFor="let state of stateList.state"
                      [value]="state.stateName"
                      required
                    >
                      {{ state.stateName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>

              <div class="card-btn checkbox-btn">
                <button
                  class="margin-top15"
                  (click)="onUpdateAddress(residenceForm)"
                  type="button"
                  [hidden]="hidesubmit"
                >
                  Submit
                </button>
                <div
                  *ngIf="!iscommupdated && ishiddencom && isKYCSuccess"
                  class="Loader-gif vh-center"
                >
                  <img src="assets/loading.gif" width="25" class="vh-center" />
                </div>
              </div>
            </form>
          </div>
        </li>

        <li
          class="show-animation margin-top15"
          *ngIf="iscommupdated && msg21 && isenable"
          style="margin-bottom: 25px !important"
        >
          <div class="timeLineMsg-right left kyc-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Current address has been updated successfully.</p>
              </div>
            </div>
          </div>
        </li>
        <li class="show-animation" *ngIf="technicalerror">
          <div class="timeLineMsg" style="margin-top: 40px !important">
            <div class="stepper-hr2"></div>
            <div class="content">
              <p>Something went wrong.</p>
              <p>Please try again after some time.</p>
            </div>
          </div>
        </li>

        <!-- Update Communication2 -->

        <li
          class="show-animation"
          *ngIf="!addressrequired && msgStepper_50 && isenable"
        >
          <div class="timeLineMsg" style="margin-top: 130px">
            <div class="content">
              <p>
                Please confirm if your current address is same as KYC address.
              </p>
            </div>
            <li class="show-animation1">
              <button
                class="reject1"
                (click)="notsameAddress()"
                [hidden]="hidebutton1"
              >
                No
              </button>
              <button
                class="accept1"
                (click)="sameAddress()"
                [hidden]="hidebutton1"
              >
                Yes
              </button>
            </li>
          </div>
        </li>

        <li
          class="show-animation margin-top15"
          *ngIf="isSameAddress && msgStepper_35 && isenable"
          style="margin: bottom 10px"
        >
          <div class="timeLineMsg-right left kyc-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Address Confirmed.</p>
              </div>
            </div>
          </div>
        </li>
        <li
          class="show-animation margin-top15"
          *ngIf="isnotSameAddress && msgStepper_37 && isenable"
          style="margin: bottom 10px"
        >
          <div class="timeLineMsg-right left kyc-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Address Not Confirmed.</p>
              </div>
            </div>
          </div>
        </li>
        <li
          class="show-animation"
          *ngIf="isSameAddress && msgStepper_36 && isenable"
        >
          <div class="timeLineMsg" style="margin-top: 100px">
            <div class="stepper-hr2"></div>
            <div class="content">
              <p>Please Take Selfie.</p>
              <p *ngIf="isretry">
                Oops! That was an unclear picture. Kindly click and send a new
                one.
              </p>
            </div>
          </div>
        </li>
        <li
          class="show-animation"
          *ngIf="isSameAddress && msgStepper_36 && isenable"
        >
          <button
            (click)="takeSelefie()"
            [disabled]="isDisabled == true"
            [hidden]="hidebutton2"
            type="button"
            [ngClass]="{ disabledClass: isDisabled == true }"
          >
            {{ kycStatus1 }}
          </button>
        </li>
        <li
          class="show-animation margin-top15"
          *ngIf="isSelfie && msgStepper_39 && !iscommupdated1 && isenable"
          style="margin-bottom: 25px !important"
        >
          <div class="timeLineMsg-right left kyc-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Selfie captured successfully.</p>
              </div>
            </div>
          </div>
        </li>

        <li
          class="show-animation margin-top15"
          *ngIf="!isSelfie && msgStepper_399 && !iscommupdated1 && isenable"
        >
          <div class="timeLineMsg-right left kyc-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Sorry!! The lender has rejected your application.</p>
              </div>
            </div>
          </div>
        </li>

        <li
          class="show-animation"
          *ngIf="!isSelfie && msgStepper_400 && !iscommupdated1 && isenable"
        >
          <div class="timeLineMsg" style="margin-top: 120px !important">
            <div class="stepper-hr2"></div>
            <div class="content">
              <p>Thank you for your time.</p>
              <p>
                You are welcome to call our Contact Center number
                <b>08064807777</b> in case you wish to know more.
              </p>
            </div>
          </div>
        </li>

        <li
          class="show-animation margin-top15"
          *ngIf="addressrequired && msgStepper_33 && isenable"
        >
          <div class="timeLineMsg-right left kyc-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Thank you for confirming the KYC.</p>
              </div>
            </div>
          </div>
        </li>
        <div
          style="margin-top: 120px"
          *ngIf="
            (isnotSameAddress && msgStepper_37 && isenable) ||
            (addressrequired && msgStepper_33 && isenable)
          "
        >
          <li
            class="show-animation"
            *ngIf="
              (!addressrequired && msgStepper_34 && isenable) ||
              (addressrequired && msgStepper_33 && isenable)
            "
            style="margin-top: 95px"
          >
            <div class="timeLineMsg">
              <img src="assets/Group 445.png" style="height: 70px" />
            </div>
          </li>
          <li
            class="show-animation"
            *ngIf="
              (!addressrequired && msgStepper_34 && isenable) ||
              (addressrequired && msgStepper_33 && isenable)
            "
            style="margin-top: 30px"
          >
            <div class="timeLineMsg">
              <div class="stepper-hr1"></div>
              <div class="content">
                <p>Please provide your Current Address.</p>
              </div>
            </div>
          </li>

          <li
            class=""
            *ngIf="
              (!addressrequired && msgStepper_34 && isenable) ||
              (addressrequired && msgStepper_33 && isenable)
            "
          >
            <div class="custom-card">
              <h4>Current Address</h4>
              <P style="color: red; font-weight: 400; max-width: 100%;overflow-wrap: break-word;">Please provide your correct residential address, as it may be verified before loan disbursal.</P>
              <form [formGroup]="residenceForm1" [hidden]="ishiddencom1">
                <ng-container>
                  <mat-form-field class="width">
                    <mat-label
                      >Flat No/ House No/ Plot No/ Building Name</mat-label
                    >
                    <input
                      matInput
                      [readonly]="disableinput1"
                      formControlName="flat"
                      required
                    />
                  </mat-form-field>

                  <mat-form-field class="width">
                    <mat-label>Cross/ Lane/ Locality/ Area/ Landmark</mat-label>
                    <input
                      matInput
                      [readonly]="disableinput1"
                      formControlName="landmark"
                      required
                      ng-readonly="disableinput1==true"
                    />
                  </mat-form-field>
                  <mat-form-field class="width">
                    <mat-label>Village/ Town / City / Post Office </mat-label>
                    <input
                      matInput
                      [readonly]="disableinput1"
                      formControlName="postOffice"
                      required
                      ng-readonly="disableinput1==true"
                    />
                  </mat-form-field>
                  <mat-form-field class="width">
                    <mat-label>Pin Code*</mat-label>

                    <input
                      matInput
                      [readonly]="disableinput1"
                      type="number"
                      formControlName="Pincode"
                      (ngModelChange)="onpinchange($event)"
                      onKeyPress="if(this.value.length==6) return false;"
                      ng-readonly="disableinput1==true"
                    />
                  </mat-form-field>
                  <div class="error" *ngIf="wrongMobile1">
                    {{ requiredMsg }}
                  </div>

                  <mat-form-field class="width">
                    <mat-label>District</mat-label>
                    <input
                      matInput
                      [readonly]="disableinput1"
                      formControlName="District"
                      required
                      ng-readonly="disableinput1==true"
                    />
                  </mat-form-field>

                  <mat-form-field class="width">
                    <mat-label>State</mat-label>
                    <mat-select
                      formControlName="State"
                      [readonly]="disableinput1"
                      required
                      ng-readonly="disableinput1==true"
                    >
                      <mat-option
                        *ngFor="let state of stateList.state"
                        [value]="state.stateName"
                      >
                        {{ state.stateName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>

                <div class="card-btn checkbox-btn">
                  <button
                    class="margin-top15 yes"
                    (click)="onUpdateAddress1(residenceForm1)"
                    type="button"
                    [disabled]="disableform"
                    [hidden]="ishiddencom"
                  >
                    Submit
                  </button>
                  <div *ngIf="loader3" class="Loader-gif vh-center">
                    <img
                      src="assets/loading.gif"
                      width="25"
                      class="vh-center"
                    />
                  </div>
                </div>
              </form>
            </div>
          </li>
        </div>

        <li
          class="show-animation margin-top15"
          *ngIf="iscommupdated1 && msg21 && isenable"
          style="margin: top 5px"
        >
          <div class="timeLineMsg-right left">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Current address has been updated successfully.</p>
              </div>
            </div>
          </div>
        </li>

        <li class="show-animation" *ngIf="iscommupdated1 && msg22 && isenable">
          <div class="timeLineMsg" style="margin-top: 100px">
            <div class="stepper-hr2"></div>
            <div class="content">
              <p>Please take your selfie to continue.</p>
              <p *ngIf="isretry">
                Oops! That was an unclear picture. Kindly click and send a new
                one.
              </p>
            </div>
          </div>
        </li>
        <li class="show-animation" *ngIf="iscommupdated1 && msg22 && isenable">
          <button
            (click)="takeSelefie()"
            [disabled]="isDisabled == true"
            [hidden]="hidebutton2"
            type="button"
            [ngClass]="{ disabledClass: isDisabled == true }"
          >
            Proceed
          </button>
        </li>

        <li
          class="show-animation margin-top15"
          *ngIf="isSelfie && msgStepper_39 && iscommupdated1 && isenable"
        >
          <div class="timeLineMsg-right left kyc-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Selfie captured successfully.</p>
              </div>
            </div>
          </div>
        </li>

        <li class="show-animation" *ngIf="technicalerror">
          <div class="timeLineMsg" style="margin-top: 90px !important">
            <div class="stepper-hr2"></div>
            <div class="content">
              <p>Something went wrong.</p>
              <p>Please try again after some time.</p>
            </div>
          </div>
        </li>

        <div *ngIf="errorsubmit">
          <div class="content">
            <p>Something went wrong.</p>
            <p>Please try again after some time.</p>
          </div>
        </div>

        <li
          class="show-animation margin-top15"
          *ngIf="!isSelfie && msgStepper_399 && iscommupdated1 && isenable"
        >
          <div class="timeLineMsg-right left kyc-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Sorry!! The lender has rejected your application.</p>
              </div>
            </div>
          </div>
        </li>

        <li
          class="show-animation"
          *ngIf="!isSelfie && msgStepper_400 && iscommupdated1 && isenable"
        >
          <div class="timeLineMsg" style="margin-top: 120px !important">
            <div class="stepper-hr2"></div>
            <div class="content">
              <p>Thank you for your time.</p>
              <p>
                You are welcome to call our Contact Center number
                <b>08064807777</b> in case you wish to know more.
              </p>
            </div>
          </div>
        </li>

        <!-- E-mandate Block 1 -->
        <li
          class="show-animation"
          *ngIf="
            (iscommupdated &&
              msg22 &&
              !nach_flag_status &&
              kyc_flag &&
              isenable) ||
            (isSelfie && msgStepper_39 && !nach_flag_status && isenable) ||
            (iscommupdated &&
              msg22 &&
              !nach_flag_status &&
              !kyc_flag &&
              isenable)
          "
        >
          <div class="timeLineMsg" style="margin-top: 130px">
            <div class="content">
              <p>Please confirm your E-mandate details available with us.</p>
            </div>
          </div>
        </li>

        <li
          class="show-animation for_custom_label"
          *ngIf="
            (iscommupdated &&
              msg22 &&
              !nach_flag_status &&
              kyc_flag &&
              isenable) ||
            (isSelfie && msgStepper_39 && !nach_flag_status && isenable) ||
            (iscommupdated &&
              msg22 &&
              !nach_flag_status &&
              !kyc_flag &&
              isenable)
          "
        >
          <div class="container1 Kyc_details_wrapper">
            <h1 class="Kyc_details">E-Mandate</h1>

            <div class="details">
              <table>
                <tbody>
                  <tr>
                    <td>Account Number</td>
                    <td>{{ Borrower_Account_Number }}</td>
                  </tr>
                  <tr class="dob">
                    <td>Account Holder Name</td>
                    <td>{{ Borrower_Name }}</td>
                  </tr>
                  <tr class="place">
                    <td>Bank</td>
                    <td>{{ Borrower_Bank_Name }}</td>
                  </tr>
                  <tr class="place">
                    <td>IFSC Code</td>
                    <td>{{ Borrower_IFSC }}</td>
                  </tr>
                </tbody>
              </table>

              <br />
              <p style="margin-bottom: 20px; font-size: 12px !important">
                *Please note that the Loan Amount will be deposited in the bank
                account registered with us and the same account will be used to
                deduct EMI.
              </p>
            </div>
            <div class="card-btn">
              <button
                class="reject"
                (click)="nonexistingnach()"
                [hidden]="hidenachbutton"
              >
                No
              </button>
              <button
                class="accept"
                (click)="existingnach()"
                [hidden]="hidenachbutton"
              >
                Yes
              </button>
            </div>

            <div class="inner-loader" *ngIf="loader4" class="vh-center">
              <img src="assets/loading.gif" width="25" style="margin: 0 auto" />
            </div>
          </div>
        </li>

        <li class="show-animation margin-top15" *ngIf="isrejected && isenable">
          <div class="timeLineMsg-right left kyc-sec">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Sorry!! the lender has rejected your application.</p>
              </div>
            </div>
          </div>
        </li>

        <li class="show-animation" *ngIf="isrejected">
          <div class="timeLineMsg" style="margin-top: 120px !important">
            <div class="stepper-hr2"></div>
            <div class="content">
              <p>Thank you for your time.</p>
              <p>
                You are welcome to call our Contact Center number
                <b>08064807777</b> in case you wish to know more.
              </p>
            </div>
          </div>
        </li>
        <li
          class="show-animation"
          *ngIf="isEMandateCompleted && msgStepper_904 && isnachyes && isenable"
        >
          <div class="timeLineMsg-right left">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>E-Mandate registration is successful.</p>
              </div>
            </div>
          </div>
        </li>
        <li class="show-animation" *ngIf="non_existing_nach && isenable">
          <div class="timeLineMsg-right left">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>No.</p>
              </div>
            </div>
          </div>
        </li>

        <div
          class="em_block margin-top45"
          style="margin-top: 120px !important"
          *ngIf="
            (iscommupdated &&
              msg22 &&
              nach_flag_status &&
              kyc_flag &&
              isenable) ||
            (isSelfie && msgStepper_39 && nach_flag_status && isenable) ||
            (iscommupdated &&
              msg22 &&
              nach_flag_status &&
              !kyc_flag &&
              isenable) ||
            (non_existing_nach && isenable)
          "
        >
          <li
            class="show-animation"
            *ngIf="
              (iscommupdated && msg22 && nach_flag_status) ||
              (isSelfie && msgStepper_39 && nach_flag_status) ||
              non_existing_nach
            "
          >
            <div class="timeLineMsg">
              <div class="stepper-hr2"></div>
              <div class="content">
                <p>
                  Please register for e-Mandate to enable easy disbursement and
                  repayment.
                </p>
                <p>
                  To set up the e-Mandate, please enter your own bank account
                  details.
                </p>
              </div>
            </div>
          </li>

          <li
            class="show-animation"
            *ngIf="
              (iscommupdated &&
                msg22 &&
                nach_flag_status &&
                kyc_flag &&
                isenable) ||
              (isSelfie && msgStepper_39 && nach_flag_status && isenable) ||
              (iscommupdated &&
                msg22 &&
                nach_flag_status &&
                !kyc_flag &&
                isenable) ||
              (non_existing_nach && isenable)
            "
          >
            <button
              (click)="kycModal(3)"
              type="button"
              [disabled]="isDisabled2 == true"
              [ngClass]="{ disabledClass: isDisabled2 == true }"
            >
              {{ emandateStatus }}
            </button>
          </li>

          <li
            class="show-animation"
            *ngIf="tryagain && msgStepper_999 && isenable"
          >
            <div class="timeLineMsg" style="margin-top: 40px !important">
              <div class="stepper-hr2"></div>
              <div class="content">
                <p>Something went wrong.</p>
                <p>Please try again after some time.</p>
              </div>
            </div>
          </li>

          <li>
            <div>
              <img
                *ngIf="
                  (!isEMandateCompleted &&
                    iscommupdated &&
                    loader2 &&
                    isenable) ||
                  (!isEMandateCompleted &&
                    iscommupdated1 &&
                    loader2 &&
                    isenable)
                "
                src="assets/loading.gif"
                width="25"
                class="Loader-gif vh-center"
              />
            </div>
          </li>

          <li
            class="show-animation margin-top15"
            *ngIf="!isEMandateCompleted && msgStepper_1010 && isenable"
          >
            <div class="timeLineMsg-right left kyc-sec">
              <div class="alt-content1">
                <div class="happy-sec">
                  <p>Sorry!! the lender has rejected your application.</p>
                </div>
              </div>
            </div>
          </li>

          <li
            class="show-animation margin-top15"
            *ngIf="rfcFailed && msgStepper_1010 && isenable"
          >
            <div class="timeLineMsg-right left kyc-sec">
              <div class="alt-content1">
                <div class="happy-sec">
                  <p>Sorry!! the lender has rejected your application.</p>
                </div>
              </div>
            </div>
          </li>

          <li
            class="show-animation"
            *ngIf="!isEMandateCompleted && msgStepper_1011 && isenable"
          >
            <div class="timeLineMsg" style="margin-top: 120px !important">
              <div class="stepper-hr2"></div>
              <div class="content">
                <p>Thank you for your time.</p>
                <p>
                  You are welcome to call our Contact Center number
                  <b>08064807777</b> in case you wish to know more.
                </p>
              </div>
            </div>
          </li>

          <li
            class="show-animation"
            *ngIf="isEMandateCompleted && msgStepper_904 && isenable"
          >
            <div class="timeLineMsg-right left">
              <div class="alt-content1">
                <div class="happy-sec">
                  <p>E-Mandate registration is successful.</p>
                </div>
              </div>
            </div>
          </li>

          <li class="show-animation" *ngIf="msgStepper_1112 && isenable">
            <div class="timeLineMsg">
              <div class="stepper-hr1"></div>
              <div class="content">
                <p class="userNAme"><strong>Sorry!</strong></p>
                <br />
                <p class="description" mat-dialog-title>
                  We are unable to serve you right now. <br />Please try again
                  after some time.
                </p>
              </div>
            </div>
          </li>
        </div>

        <div *ngIf="rfcFailed1 && isenable" style="margin-top: 100px">
          <li class="show-animation">
            <div class="timeLineMsg">
              <div class="stepper-hr2"></div>
              <div class="content">
                <p>
                  Please register for e-Mandate to enable easy disbursement and
                  repayment.
                </p>
                <p>
                  To set up the e-Mandate, please enter your own bank account
                  details.
                </p>
              </div>
            </div>
          </li>
          <li class="show-animation">
            <div class="timeLineMsg-right left">
              <div class="alt-content1">
                <div class="happy-sec">
                  <p>E-Mandate registration is successful.</p>
                </div>
              </div>
            </div>
          </li>
          <li class="show-animation" style="margin-top: 70px">
            <div class="timeLineMsg-right left kyc-sec">
              <div class="alt-content1">
                <div class="happy-sec">
                  <p>Sorry!! the lender has rejected your application.</p>
                </div>
              </div>
            </div>
          </li>
        </div>

        <li
          class="show-animation"
          *ngIf="isSubmittedComm && msgStepper_504 && isenable"
        >
          <div class="timeLineMsg left-allign">
            <img
              src="assets/new-icons/afterPersonalInfo.png"
              class="status_img_height"
            />
          </div>
        </li>

        <!-- E-mandate Block 2 -->

        <!-- LDS Block -->
        <!-- Top Up LDS -->
        <!-- <li class="show-animation" *ngIf="topuppromoinvalid" style="margin-top: 80px;">
    <div>
        <div class="stepper-hr1"></div>
        <div class="content-promo">
            <p style="color: red; margin-top: 5px;">Promo code invalid</p>
        </div>
    </div>
</li> -->

        <li
          class="show-animation"
          *ngIf="
            (isEMandateCompleted &&
              msgStepper_10011 &&
              showTopupOffer &&
              isenable
               )||
            (iscommupdated &&
              !nach_flag_status &&
              isEMandateCompleted &&
              showTopupOffer &&
              isenable ) ||
            (isSelfie &&
              msgStepper_39 &&
              !nach_flag_status &&
              isEMandateCompleted &&
              showTopupOffer &&
              isenable )
          "
        >
          <div class="container_topup1">
            <div class="inner__bottom">
              <div class="inner__botton__content">
                <p>Your Top up loan details.</p>

                <div class="inner__bottom_details">
                  <p>Total Loan Amount (A)</p>
                  <p>₹ {{ offerAmount1 }}</p>
                </div>

                <div class="inner__bottom_details">
                  <p>Total Outstanding (B)</p>
                  <p>₹ {{ outstanding }}</p>
                </div>

                <div class="inner__bottom_details">
                  <p>Top-up Loan Amount (A - B)</p>
                  <p>₹ {{ topupamount1 }}</p>
                </div>

                <div class="inner__bottom_details">
                  <p>
                    Processing fee <span class="changecolor">(Incl. GST)</span>
                  </p>
                  <div class="front-promo" *ngIf="!topuppromoapplied">
                    <span style="font-size: 14px"
                      >₹ {{ processing_fee1 }}</span
                    >
                    <!-- <s style="font-size: 12px; font-weight: 400;">₹ {{ PF_after_promo| inrFormat}}</s> -->
                  </div>
                  <div class="front-promo" *ngIf="topuppromoapplied">
                    <span style="font-size: 14px"
                      >₹ {{ PF_after_promo | inrFormat }}</span
                    >
                    <s style="font-size: 12px; font-weight: 400">₹ {{ processing_fee1 | inrFormat }}</s>
                  </div>
                </div>

                <div class="inner__bottom_details">
                  <p>Net Disbursal Amount</p>
                  <p>₹ {{ disburseamount1 }}</p>
                </div>

                <div class="inner__bottom_details">
                  <p>Loan Tenor</p>
                  <p>{{ offertenor }} months</p>
                </div>

                <div class="inner__bottom_details">
                  <p>Interest Rate</p>
                  <p>{{ offerroi }}</p>
                </div>

                <div class="inner__bottom_details">
                  <p>New EMI</p>
                  <p>₹ {{ offeremi1 }} p.m.</p>
                </div>
              </div>
            </div>
          </div>
        </li>

        <li
          *ngIf="
            (isEMandateCompleted &&
              msgStepper_10011 &&
              showTopupOffer &&
              promoapplicable &&
              isenable) ||
            (iscommupdated &&
              !nach_flag_status &&
              isEMandateCompleted &&
              showTopupOffer &&
               promoapplicable &&
              isenable) ||
            (isSelfie &&
              msgStepper_39 &&
              !nach_flag_status &&
              isEMandateCompleted &&
              showTopupOffer &&
              promoapplicable &&
              isenable)
          "
        >
          <div
            class="content-promo1"
            *ngIf="
              (isEMandateCompleted &&
                msgStepper_10011 &&
                showTopupOffer &&
                promoapplicable &&
                isenable) ||
              (iscommupdated &&
                !nach_flag_status &&
                isEMandateCompleted &&
                showTopupOffer &&
                promoapplicable &&
                isenable) ||
              (isSelfie &&
                msgStepper_39 &&
                !nach_flag_status &&
                isEMandateCompleted &&
                showTopupOffer &&
                promoapplicable &&
                isenable)
            "
          >
            <div  *ngIf="
            (isEMandateCompleted &&
              msgStepper_10011 &&
              showTopupOffer &&
              promoapplicable &&
              isenable) ||
            (iscommupdated &&
              !nach_flag_status &&
              isEMandateCompleted &&
              showTopupOffer &&
               promoapplicable &&
              isenable) ||
            (isSelfie &&
              msgStepper_39 &&
              !nach_flag_status &&
              isEMandateCompleted &&
              showTopupOffer &&
              promoapplicable &&
              isenable)
          ">
              <p>
                <span class="promo-code">Do you have a Promo Code? </span>
                <span class="code-box-btn">
                  <span class="box-line">
                    <input
                      type="text"
                      id="inputField"
                      class="code-input"
                      matInput
                      placeholder="Enter Here"
                      [(ngModel)]="topuppromocode"
                    />
                    <span class="line"></span>
                  </span>

                  <button
                    id="submitButton"
                    style="margin-bottom: 0px !important"
                    (click)="onSubmitTopupPromo()"
                    [disabled]="applydisable"
                    [ngClass]="{ disabledClass: applydisable == true }"
                  >
                    Apply
                  </button>
                </span>
              </p>
            </div>
          </div>
        </li>
        <!--Topup  Promo invalid repeat--->

        <li
          class="show-animation"
          *ngIf="topuppromoinvalid && isenable"
          style="margin-top: 5px"
        >
          <div>
            <div class="stepper-hr1"></div>
            <div class="content-promo">
              <p style="color: red; margin-top: 20px">Promo code invalid</p>
            </div>
          </div>
        </li>

        <li
          class="show-animation"
          style="margin-top: -51px"
          *ngIf="
            (topuppromoinvalid &&
              isEMandateCompleted &&
              msgStepper_10011 &&
              showTopupOffer &&
              isenable) ||
            (topuppromoinvalid && 
              iscommupdated &&
              !nach_flag_status &&
              isEMandateCompleted &&
              showTopupOffer &&
              isenable) ||
            (topuppromoinvalid && 
               isSelfie &&
              msgStepper_39 &&
              !nach_flag_status &&
              isEMandateCompleted &&
              showTopupOffer &&
              isenable)
          "
        >
          <div class="container_topup1">
            <div class="inner__bottom">
              <div class="inner__botton__content">
                <p>Your Top up loan details.</p>

                <div class="inner__bottom_details">
                  <p>Total Loan Amount (A)</p>
                  <p>₹ {{ offerAmount1 }}</p>
                </div>

                <div class="inner__bottom_details">
                  <p>Total Outstanding (B)</p>
                  <p>₹ {{ outstanding }}</p>
                </div>

                <div class="inner__bottom_details">
                  <p>Top-up Loan Amount (A - B)</p>
                  <p>₹ {{ topupamount1 }}</p>
                </div>

                <div class="inner__bottom_details">
                  <p>
                    Processing fee <span class="changecolor">(Incl. GST)</span>
                  </p>
                  <div class="front-promo" *ngIf="!topuppromoapplied">
                    <span style="font-size: 14px">₹ {{ processing_fee1}}</span>
                    <!-- <s style="font-size: 12px; font-weight: 400;">₹ {{ PF_after_promo| inrFormat}}</s> -->
                  </div>
                  <div class="front-promo" *ngIf="topuppromoapplied">
                    <span style="font-size: 14px"
                      >₹ {{ PF_after_promo | inrFormat }}</span
                    >
                    <s style="font-size: 12px; font-weight: 400"
                      >₹ {{ processing_fee1}}</s
                    >
                  </div>
                </div>

                <div class="inner__bottom_details">
                  <p>Net Disbursal Amount</p>
                  <p>₹ {{ disburseamount1 }}</p>
                </div>

                <div class="inner__bottom_details">
                  <p>Loan Tenor</p>
                  <p>{{ offertenor }} months</p>
                </div>

                <div class="inner__bottom_details">
                  <p>Interest Rate</p>
                  <p>{{ offerroi }}</p>
                </div>

                <div class="inner__bottom_details">
                  <p>New EMI</p>
                  <p>₹ {{ offeremi1 }} p.m.</p>
                </div>
              </div>
            </div>
          </div>
        </li>

        <li
          *ngIf="
            (topuppromoinvalid &&
              isEMandateCompleted &&
              msgStepper_10011 &&
              showTopupOffer &&
              promoapplicable) ||
            (topuppromoinvalid &&
            iscommupdated &&
              !nach_flag_status &&
              isEMandateCompleted &&
              showTopupOffer &&
              promoapplicable &&
              isenable) ||
            ( topuppromoinvalid && 
            isSelfie &&
              msgStepper_39 &&
              !nach_flag_status &&
              isEMandateCompleted &&
              showTopupOffer &&
              promoapplicable &&
              isenable)
          "
        >
          <div
            class="content-promo1"
            *ngIf="
              (topuppromoinvalid &&
              isEMandateCompleted &&
                msgStepper_10011 &&
                showTopupOffer &&
                promoapplicable &&
                isenable) ||
              (iscommupdated &&
              topuppromoinvalid &&
                !nach_flag_status &&
                isEMandateCompleted &&
                showTopupOffer &&
                promoapplicable &&
                isenable) ||
              (isSelfie &&
              topuppromoinvalid &&
                msgStepper_39 &&
                !nach_flag_status &&
                isEMandateCompleted &&
                showTopupOffer &&
                promoapplicable &&
                isenable)
            "
          >
            <div>
              <p>
                <span class="promo-code">Do you have a Promo Code? </span>
                <span class="code-box-btn">
                  <span class="box-line">
                    <input
                      type="text"
                      id="inputField"
                      class="code-input"
                      matInput
                      placeholder="Enter Here"
                      [(ngModel)]="topuppromocode1"
                    />
                    <span class="line"></span>
                  </span>

                  <button
                    id="submitButton"
                    style="margin-bottom: 0px !important"
                    (click)="onSubmitTopupPromo1()"
                    [disbled]="applydisable1"
                    [ng-class]="{ disabledClass: applydisable1 }"
                  >
                    Apply
                  </button>
                </span>
              </p>
            </div>
          </div>
        </li>

        <!-- Topup Promo invalid repeat--->
        <li
          class="show-animation"
          *ngIf="topuppromoapplied && isenable"
          style="margin-top: 20px; margin-bottom: 20px"
        >
          <div>
            <div class="stepper-hr1"></div>
            <div class="content-promo">
              <p>Promo code applied successfully !</p>
            </div>
          </div>
        </li>
        <li
          class="show-animation"
          *ngIf="topuppromoattemptleft && isenable"
          style="margin-top: 80px"
        >
          <div>
            <div class="stepper-hr1"></div>
            <div class="content-promo">
              <p>No attempts left !</p>
            </div>
          </div>
        </li>

        <li
          class="show-animation"    
          [ngStyle] ="{ 'margin-top': '40px' }"
          *ngIf="(isEMandateCompleted &&
              msgStepper_10011 &&
              showTopupOffer &&
              promoapplicable &&
              isenable) ||
            (iscommupdated &&
              !nach_flag_status &&
              isEMandateCompleted &&
              showTopupOffer &&
              promoapplicable &&
              isenable) ||
            (isSelfie &&
              msgStepper_39 &&
              !nach_flag_status &&
              isEMandateCompleted &&
              showTopupOffer &&
              promoapplicable &&
              isenable)
          "
        >
          <button
            (click)="onTopupconfirm()"
            [disabled]="istopupcardConfirmed"
            [ngClass]="{ disabledClass: istopupcardConfirmed == true }"
         
          >
            Confirm Details
          </button>
        </li>
        <li
          class="show-animation setmargin"
          *ngIf="
            (isEMandateCompleted &&
              msgStepper_10011 &&
              showTopupOffer &&
              !promoapplicable &&
              isenable) ||
            (iscommupdated &&
              !nach_flag_status &&
              isEMandateCompleted &&
              showTopupOffer &&
              !promoapplicable &&
              isenable) ||
            (isSelfie &&
              msgStepper_39 &&
              !nach_flag_status &&
              isEMandateCompleted &&
              showTopupOffer &&
              !promoapplicable &&
              isenable)
          "
        >
          <button
            (click)="onTopupcardconfirm()"
            [disabled]="istopupcardConfirmed"
            [ngClass]="{ disabledClass: istopupcardConfirmed == true }"
            [ngStyle] ="{ 'margin-top': '40px' }"
          >
            Confirm Details
          </button>
        </li>
        <li
          class="show-animation"
          style="margin-top: 70px"
          *ngIf="
            (isEMandateCompleted &&
              msgStepper_10011 &&
              showTopupOffer &&
              istopupcardConfirmed &&
              !promoapplicable &&
              isenable) ||
            (iscommupdated &&
              !nach_flag_status &&
              isEMandateCompleted &&
              showTopupOffer &&
              istopupcardConfirmed &&
              !promoapplicable &&
              isenable) ||
            (isSelfie &&
              msgStepper_39 &&
              !nach_flag_status &&
              isEMandateCompleted &&
              showTopupOffer &&
              istopupcardConfirmed &&
              !promoapplicable &&
              isenable)
          "
        >
          <div class="timeLineMsg-right left">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Loan details confirmed successfully.</p>
              </div>
            </div>
          </div>
        </li>

        <!-- KFS Signing -->

        <li
          class="show-animation"
          style="margin-top: 70px"
          *ngIf="
            (isEMandateCompleted &&
              msgStepper_10011 &&
              showTopupOffer &&
              istopupcardConfirmed &&
              !isdetailsconfirmed &&
              !topuppromoinvalid &&
              isenable) ||
            (iscommupdated &&
              !nach_flag_status &&
              isEMandateCompleted &&
              showTopupOffer &&
              istopupcardConfirmed &&
              !isdetailsconfirmed &&
              !topuppromoinvalid &&
              isenable) ||
            (isSelfie &&
              msgStepper_39 &&
              !nach_flag_status &&
              isEMandateCompleted &&
              showTopupOffer &&
              istopupcardConfirmed &&
              !isdetailsconfirmed &&
              !topuppromoinvalid &&
              isenable)
          "
        >
          <div
            class="left-allign margin-top200"
            style="margin-left: -10px; margin-top: 200"
          >
            <img
              src="assets/new-icons/afterTerms.png"
              class="status_img_height"
            />
          </div>
        </li>

        <li
          class="show-animation"
          *ngIf="
            (isEMandateCompleted &&
              msgStepper_10011 &&
              showTopupOffer &&
              istopupcardConfirmed &&
              !isdetailsconfirmed &&
              !topuppromoinvalid &&
              isenable) ||
            (iscommupdated &&
              !nach_flag_status &&
              isEMandateCompleted &&
              showTopupOffer &&
              istopupcardConfirmed &&
              !isdetailsconfirmed &&
              !topuppromoinvalid &&
              isenable) ||
            (isSelfie &&
              msgStepper_39 &&
              !nach_flag_status &&
              isEMandateCompleted &&
              showTopupOffer &&
              istopupcardConfirmed &&
              !isdetailsconfirmed &&
              !topuppromoinvalid &&
              isenable)
          "
        >
          <div>
            <div class="content1">
              <b>Enter OTP</b><br />Please enter the OTP sent to {{ Mobile }} to
              accept the Loan
              <button
                type="button"
                data-toggle="modal"
                data-target="#exampleModal"
                class="linkbutton"
                (click)="kycModal(4)"
                [disabled]="isDisabled5 == true"
              >
                Terms and Conditions.
              </button>
            </div>
            <div class="otpcontainer kfs-otp-container" *ngIf="otp_input">
              <ng-otp-input
                #ngOtpInput
                (onInputChange)="KFS_otp_verify($event)"
                [config]="config1"
                [ngClass]="{ otpErrorClass: otperror }"
              ></ng-otp-input>
              <!-- <p style="display: flex";><span class="wrongOTP">Invalid OTP</span> <span style="text-align: right;">0:00 Sec</span></p>  -->
              <div class="error-container" [hidden]="kfsotpverified">
                <p class="otperror">{{ Errormessage }}</p>
                <p
                  *ngIf="resend_OTP"
                  (click)="KFS_otp_send()"
                  style="cursor: pointer; color: #1066ad"
                  [hidden]="kfsotpverified"
                >
                  Resend OTP
                </p>
                <p *ngIf="!resend_OTP">{{ timeLeft }} sec</p>
              </div>
            </div>
            <button
              (click)="kycModal(5)"
              type="button"
              [hidden]="isDisabled4 == true"
              type="button"
              [ngClass]="{ disabledClass: isDisabled4 == true }"
            >
              Confirm
            </button>
            <div></div>
          </div>
          <div class="custom-lds-model">
            <div
              class="modal fade"
              id="exampleModal"
              tabindex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div
                class="inner-loader z-1000 fixed trbl-0 vh-center bg-white-50 blur-2"
                style="height: 100%"
                *ngIf="Modelloader1"
              >
                <img src="assets/loading.gif" width="25" class="vh-center" />
              </div>
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <p class="modal-title" id="exampleModalLabel">
                      Loan Terms & Conditions
                    </p>
                    <button
                      type="button"
                      class="close"
                      #closemodal
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <!-- Dynamic KFS -->
                    <div class="cst-dynamic-kfs">
                      <div *ngFor="let item of response">
                        <div [innerHTML]="item"></div>
                      </div>
                    </div>
                    <div [innerHTML]="item"></div>
                    <!-- -----End-Loader-Section---- -->

                    <!-- --------------------------LDS-section---- -->
                    <!-- ------------Button-div -->
                    <div class="continue_bottom_btn">
                      <mat-card>
                        <div class="submit">
                          <!-- <div class="submit-inner">
                                        <mat-checkbox [disabled]="disablecheckbox" (change)="oncheckclick($event)">I
                                            agree to the Terms and Conditions</mat-checkbox>
                                             [ngClass]="{'disabledClass': disableldsaccept==true}"
                                    </div> -->
                          <div class="continue-btn button_div_common">
                            <button
                              class="click-btn pointer"
                              (click)="onldsAccept()"
                            >
                              <span class="button_div_common_text"
                                >Continue</span
                              ><span style="float: right" class="pd-right-0"
                                ><svg
                                  width="23"
                                  height="19"
                                  viewBox="0 0 23 19"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M22.7052 8.68674L16.4023 1.03344C15.8806 0.449655 15.0447 0.394072 14.4957 0.843451C13.9468 1.29283 13.8564 2.20104 14.3061 2.74996L18.7942 8.19471H1.84103C1.09521 8.19471 0.490356 8.79954 0.490356 9.54539C0.490356 10.2912 1.09518 10.8961 1.84103 10.8961H18.7942L14.3061 16.3408C13.8567 16.8894 13.9578 17.7851 14.4957 18.2473C15.0506 18.724 15.9529 18.6063 16.4023 18.0573L22.7052 10.404C23.1156 9.82716 23.0805 9.24558 22.7052 8.6875V8.68674Z"
                                    fill="white"
                                  />
                                </svg>
                              </span>
                            </button>
                          </div>
                        </div>
                      </mat-card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <!-- Top Up LDS -->
        <!-- X-Sell lds -->
        <li
          class="show-animation"
          *ngIf="
            (isEMandateCompleted &&
              msgStepper_10011 &&
              !showTopupOffer &&
              showinsurance &&
              isenable) ||
            (iscommupdated &&
              !nach_flag_status &&
              isEMandateCompleted &&
              !showTopupOffer &&
              showinsurance &&
              isenable) ||
            (isSelfie &&
              msgStepper_39 &&
              !nach_flag_status &&
              isEMandateCompleted &&
              !showTopupOffer &&
              showinsurance &&
              isenable)
          "
        >
          <div class="container_topup1" style="margin-bottom: 20px">
          
            <div class="inner__bottom">
              <div class="inner__botton__content">
                <p>Your loan details.</p>
                <div class="inner__bottom_details">
                  <p>Loan Amount</p>
                  <p>₹ {{ GridAmount | inrFormat }}</p>
                </div>

                <div class="inner__bottom_details">
                  <p>Loan Tenor</p>
                  <p>{{ GridTenor }} months</p>
                </div>
                <div class="inner__bottom_details">
                  <p>Interest Rate</p>
                  <p>{{ GridRoi }} %</p>
                </div>
                <div class="inner__bottom_details">
                  <p>EMI Amount</p>
                  <p>₹{{ GridEmi | inrFormat }}p.m.</p>
                </div>
                <div class="inner__bottom_details">
                  <p>Processing fee <span>(Incl. GST)</span></p>
                  <p>₹ {{ GridProcessingFee | inrFormat }}</p>
                </div>
                <div class="inner__bottom_details" *ngIf="insurance_opted">
                  <p class="changecolor">'Finprotect Gold' Fee</p>
                  <p>₹{{ insurance_premium | inrFormat }}</p>
                </div>
                <div class="inner__bottom_details">
                  <p *ngIf="!insurance_opted">
                    <b>Amount to be Received in account.</b><br />
                    <span>Post deduction of processing fees </span>
                  </p>
                  <p *ngIf="insurance_opted">
                    <b>Amount to be Received in account.</b><br />
                    <span
                      >Post deduction of processing and 'Finprotect Gold'
                      Fee</span
                    >
                  </p>
                  <p>₹ {{ netdisbusedamount | inrFormat }}</p>
                </div>
              </div>
            </div>
            <div class="insurance">
              <label class="custom-checkbox">
                <input
                  type="checkbox"
                  (change)="insurance_unchecked($event)"
                  [disabled]="insurancedisablecheckbox"
                />
              </label>
              <div>               
             <h4>Secure your loan with <span class="finprotect"   (click)="showinsurancedoc()">'Finprotect Gold'</span></h4>
                <p> Enjoy unlimited 24/7 doctor access 
                 for your health concerns and get a benefit
                  to safeguard your loan during challenging times - all for just <b>₹{{insurance_premium}}</b>
                  <br><b>(that's ₹{{insurance_per_day}}/day)</b>
                </p>
              </div>
            </div>
          </div>
          <div style="margin-top: 10px">
            <li class="show-animation">
              <!-- <p
                style="margin-left: 5px"
                class="linkbutton1"
                *ngIf="insurance_opted"
                (click)="showinsurancedoc()"
                [disabled]="insurancedisablecheckbox"
              >
                'Finprotect Gold' Details
              </p> -->
              <div class="content-promo" *ngIf="promoapplicable">
                <div>
                  <p>
                    <span class="promo-code">Do you have a Promo Code? </span>
                    <span class="code-box-btn">
                      <span class="box-line">
                        <input
                          type="text"
                          id="inputField"
                          class="code-input"
                          matInput
                          placeholder="Enter Here"
                          [(ngModel)]="promocode"
                        />
                        <span class="line"></span>
                      </span>

                      <button
                        id="submitButton"
                        style="margin-bottom: 0px !important"
                        (click)="onSubmitPromo()"
                        *ngIf="buttondisabled"
                      >
                        Apply
                      </button>
                    </span>
                  </p>
                </div>
              </div>
            
            <div [ngStyle] ="{ 'margin-top': '10px' }">
              <button
              (click)="onInsuranceconfirm()"
              [hidden]="isdetailsconfirmed"
            >
              Confirm Details
            </button>
       </div>
             
            </li>
          </div>
        </li>

  

        <li class="show-animation" *ngIf="promoinvalid && isenable">
          <div>
            <div class="stepper-hr1"></div>
            <div class="content-promo">
              <p style="color: red; margin-top: 5px">Promo code invalid</p>
            </div>
          </div>
        </li>
        <li
          class="show-animation"
          *ngIf="
            promoinvalid &&
            ((isEMandateCompleted &&
              msgStepper_10011 &&
              !showTopupOffer &&
              showinsurance &&
              isenable) ||
              (iscommupdated &&
                !nach_flag_status &&
                isEMandateCompleted &&
                !showTopupOffer &&
                showinsurance &&
                isenable) ||
              (isSelfie &&
                msgStepper_39 &&
                !nach_flag_status &&
                isEMandateCompleted &&
                !showTopupOffer &&
                showinsurance &&
                isenable))
          "
        >
          <div class="container_topup2" style="margin-bottom: 20px">
         
            <div class="inner__bottom">
              <div class="inner__botton__content">
                <p>Your loan details.</p>
                <div class="inner__bottom_details">
                  <p>Loan Amount</p>
                  <p>₹ {{ GridAmount | inrFormat }}</p>
                </div>

                <div class="inner__bottom_details">
                  <p>Loan Tenor</p>
                  <p>{{ GridTenor }} months</p>
                </div>
                <div class="inner__bottom_details">
                  <p>Interest Rate</p>
                  <p>{{ GridRoi }} %</p>
                </div>
                <div class="inner__bottom_details">
                  <p>EMI Amount</p>
                  <p>₹{{ GridEmi | inrFormat }}p.m.</p>
                </div>
                <div class="inner__bottom_details">
                  <p>Processing fee <span>(Incl. GST)</span></p>
                  <p>₹ {{ GridProcessingFee | inrFormat }}</p>
                </div>
                <div class="inner__bottom_details" *ngIf="insurance_opted">
                  <p class="changecolor">'Finprotect Gold' Fee</p>
                  <p>₹{{ insurance_premium | inrFormat }}</p>
                </div>
                <div class="inner__bottom_details">
                  <p *ngIf="!insurance_opted">
                    <b>Amount to be Received in account.</b><br />
                    <span>Post deduction of processing fees </span>
                  </p>
                  <p *ngIf="insurance_opted">
                    <b>Amount to be Received in account.</b><br />
                    <span
                      >Post deduction of processing and 'Finprotect Gold'
                      Fee</span
                    >
                  </p>
                  <p>₹ {{ netdisbusedamount | inrFormat }}</p>
                </div>
              </div>
            </div>
            <div class="insurance">
              <label class="custom-checkbox">
                <input
                  type="checkbox"
                  (change)="insurance_unchecked($event)"
                  [disabled]="insurancedisablecheckbox"
                />
              </label>
              <div>
              <h4>Secure your loan with <span class="finprotect"   (click)="showinsurancedoc()">'Finprotect Gold'</span></h4>
                <p> Enjoy unlimited 24/7 doctor access 
                 for your health concerns and get a benefit
                  to safeguard your loan during challenging times - all for just <b>₹{{insurance_premium}}</b>
                  <br><b>(that's ₹{{insurance_per_day}}/day)</b>
                </p>
              </div>
            </div>
          </div>
          <div style="margin-top: 10px">
            <li class="show-animation">
              <!-- <p
                style="margin-left: 5px"
                class="linkbutton1"
                *ngIf="insurance_opted && isenable"
                (click)="showinsurancedoc()"
                [disabled]="insurancedisablecheckbox"
              >
                'Finprotect Gold' Details
              </p> -->
              <div class="content-promo" *ngIf="promoapplicable && isenable">
                <div>
                  <p>
                    <span class="promo-code">Re- enter your Promo Code </span>
                    <span class="code-box-btn">
                      <span class="box-line">
                        <input
                          type="text"
                          id="inputField"
                          class="code-input"
                          matInput
                          placeholder="Enter Here"
                          [(ngModel)]="promocode1"
                        />
                        <span class="line"></span>
                      </span>

                      <button
                        id="submitButton"
                        style="margin-bottom: 0px !important"
                        (click)="onSubmitPromo1()"
                        *ngIf="Repromoapplicable"
                      >
                        Apply
                      </button>
                    </span>
                  </p>
                </div>
              </div>
          <div [ngStyle] ="{ 'margin-top': '10px' }">
                <button
                (click)="onInsuranceconfirm()"
                [hidden]="isdetailsconfirmed"
              >
                Confirm Details
              </button>
           </div>
             
            </li>
          </div>
        </li>

        <li class="show-animation" *ngIf="promoapplied && isenable">
          <div>
            <div class="stepper-hr1"></div>
            <div class="content-promo" style="margin-top: 5px">
              <p>Promo code applied successfully !</p>
            </div>
          </div>
        </li>
        <li
          class="show-animation"
          *ngIf="
            promoapplied &&
            ((isEMandateCompleted &&
              msgStepper_10011 &&
              !showTopupOffer &&
              showinsurance &&
              isenable) ||
              (iscommupdated &&
                !nach_flag_status &&
                isEMandateCompleted &&
                !showTopupOffer &&
                showinsurance &&
                isenable) ||
              (isSelfie &&
                msgStepper_39 &&
                !nach_flag_status &&
                isEMandateCompleted &&
                !showTopupOffer &&
                showinsurance &&
                isenable))
          "
        >
          <div class="container_topup2" style="margin-bottom: 20px">
         
            <div class="inner__bottom">
              <div class="inner__botton__content">
                <p>Your loan details.</p>
                <div class="inner__bottom_details">
                  <p>Loan Amount</p>
                  <p>₹ {{ GridAmount | inrFormat }}</p>
                </div>

                <div class="inner__bottom_details">
                  <p>Loan Tenor</p>
                  <p>{{ GridTenor }} months</p>
                </div>
                <div class="inner__bottom_details">
                  <p>Interest Rate</p>
                  <p>{{ GridRoi }} %</p>
                </div>
                <div class="inner__bottom_details">
                  <p>EMI Amount</p>
                  <p>₹{{ GridEmi | inrFormat }}p.m.</p>
                </div>
                <div class="inner__bottom_details">
                  <p>Processing fee <span>(Incl. GST)</span></p>
                  <div class="front-promo">
                    <span style="font-size: 14px"
                      >₹ {{ PF_after_promo | inrFormat }}</span
                    >
                    <s style="font-size: 12px; font-weight: 400"
                      >₹ {{ GridProcessingFee | inrFormat }}</s
                    >
                  </div>
                </div>
                <div class="inner__bottom_details" *ngIf="insurance_opted">
                  <p class="changecolor">'Finprotect Gold' Fee</p>
                  <p>₹{{ insurance_premium | inrFormat }}</p>
                </div>
                <div class="inner__bottom_details">
                  <p *ngIf="!insurance_opted">
                    <b>Amount to be Received in account.</b><br />
                    <span>Post deduction of processing fees </span>
                  </p>
                  <p *ngIf="insurance_opted">
                    <b>Amount to be Received in account.</b><br />
                    <span
                      >Post deduction of processing fee and insurance
                      premium</span
                    >
                  </p>
                  <p>₹ {{ netdisbusedamount + Discounted_PF | inrFormat }}</p>
                </div>
              </div>
            </div>
            <div class="insurance">
              <label class="custom-checkbox">
                <input
                  type="checkbox"
                  (change)="insurance_unchecked($event)"
                  [disabled]="insurancedisablecheckbox"
                />
              </label>
              <div>
                <h4>Secure your loan with <span class="finprotect"   (click)="showinsurancedoc()">'Finprotect Gold'</span></h4>
                <p> Enjoy unlimited 24/7 doctor access 
                 for your health concerns and get a benefit
                  to safeguard your loan during challenging times- all for just <b>₹{{insurance_premium}}</b>
                  <br><b>(that's ₹{{insurance_per_day}}/day)</b>
                </p>
              </div>
            </div>
          </div>
          <div style="margin-top: 10px">
            <li class="show-animation">
              <!-- <p
                style="margin-left: 5px"
                class="linkbutton1"
                *ngIf="insurance_opted"
                (click)="showinsurancedoc()"
                [disabled]="insurancedisablecheckbox"
              >
                'Finprotect Gold' Details
              </p> -->
              <div [ngStyle] ="{ 'margin-top': '10px' }">
                <button
                (click)="onInsuranceconfirm()"
                [hidden]="isdetailsconfirmed"
              >
                Confirm Details
              </button>
          </div>
              
            </li>
          </div>
        </li>

        <li class="show-animation" *ngIf="promoattemptleft && isenable">
          <div>
            <div class="stepper-hr1"></div>
            <div class="content-promo">
              <p>No attempts left !</p>
            </div>
          </div>
        </li>
        <li
          class="show-animation"
          *ngIf="
            promoattemptleft &&
            ((isEMandateCompleted &&
              msgStepper_10011 &&
              !showTopupOffer &&
              showinsurance &&
              isenable) ||
              (iscommupdated &&
                !nach_flag_status &&
                isEMandateCompleted &&
                !showTopupOffer &&
                showinsurance &&
                isenable) ||
              (isSelfie &&
                msgStepper_39 &&
                !nach_flag_status &&
                isEMandateCompleted &&
                !showTopupOffer &&
                showinsurance &&
                isenable))
          "
        >
          <div class="container_topup2" style="margin-bottom: 20px">
           
            <div class="inner__bottom">
              <div class="inner__botton__content">
                <p>Your loan details.</p>
                <div class="inner__bottom_details">
                  <p>Loan Amount</p>
                  <p>₹ {{ GridAmount | inrFormat }}</p>
                </div>

                <div class="inner__bottom_details">
                  <p>Loan Tenor</p>
                  <p>{{ GridTenor }} months</p>
                </div>
                <div class="inner__bottom_details">
                  <p>Interest Rate</p>
                  <p>{{ GridRoi }} %</p>
                </div>
                <div class="inner__bottom_details">
                  <p>EMI Amount</p>
                  <p>₹{{ GridEmi | inrFormat }}p.m.</p>
                </div>
                <div class="inner__bottom_details">
                  <p>Processing fee <span>(Incl. GST)</span></p>
                  <div class="front-promo">
                    <p>₹ {{ GridProcessingFee | inrFormat }}</p>
                  </div>
                </div>
                <div class="inner__bottom_details" *ngIf="insurance_opted">
                  <p class="changecolor">'Finprotect Gold' Fee</p>
                  <p>₹{{ insurance_premium | inrFormat }}</p>
                </div>
                <div class="inner__bottom_details">
                  <p *ngIf="!insurance_opted">
                    <b>Amount to be Received in account.</b><br />
                    <span>Post deduction of processing fees </span>
                  </p>
                  <p *ngIf="insurance_opted">
                    <b>Amount to be Received in account.</b><br />
                    <span
                      >Post deduction of processing fee and insurance
                      premium</span
                    >
                  </p>
                  <p>₹ {{ netdisbusedamount | inrFormat }}</p>
                </div>
              </div>
            </div>
            <div class="insurance">
              <label class="custom-checkbox">
                <input
                  type="checkbox"
                  (change)="insurance_unchecked($event)"
                  [disabled]="insurancedisablecheckbox"
                />
              </label>
              <div>
             <h4>Secure your loan with <span class="finprotect"   (click)="showinsurancedoc()">'Finprotect Gold'</span></h4>
                 <p> Enjoy unlimited 24/7 doctor access 
                 for your health concerns and get a benefit
                  to safeguard your loan during challenging times - all for just <b>₹{{insurance_premium}}</b>
                  <br><b>(that's ₹{{insurance_per_day}}/day)</b>
              </p>
              </div>
            </div>
          </div>
          <div style="margin-top: 10px">
            <li class="show-animation">
              <!-- <p
                style="margin-left: 5px"
                class="linkbutton1"
                *ngIf="insurance_opted"
                (click)="showinsurancedoc()"
                [disabled]="insurancedisablecheckbox"
              >
                'Finprotect Gold' Details
              </p> -->
<div [ngStyle] ="{ 'margin-top': '10px' }">
  <button
  (click)="onInsuranceconfirm()"
  [hidden]="isdetailsconfirmed"
>
  Confirm Details
</button>

  </div>
              
            </li>
          </div>
        </li>


 
        <!-- X-Sell lds -->

        <li
          class="show-animation"
          *ngIf="
           ((isEMandateCompleted &&
              msgStepper_10011 &&
              isdetailsconfirmed &&
              isenable) ||
            (iscommupdated &&
              !nach_flag_status &&
              isEMandateCompleted &&
              isdetailsconfirmed &&
              isenable) ||
            (isSelfie &&
              msgStepper_39 &&
              !nach_flag_status &&
              isEMandateCompleted &&
              isdetailsconfirmed &&
              isenable) ||
            (isdetailsconfirmed && isdetailsconfirmed && isenable)) &&
           (!isFingoldconfirmed)
          "
        >
          <div class="timeLineMsg-right left">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Loan details confirmed successfully.</p>
              </div>
            </div>
          </div> 

        </li> 
        <!-- INSURANCE NUDGE CARD  -->
    
        <li class="fin-card show-animation"  *ngIf="
       ( (isEMandateCompleted &&
          msgStepper_10011 &&
          isdetailsconfirmed &&
          isenable) ||
        (iscommupdated &&
          !nach_flag_status &&
          isEMandateCompleted &&
          isdetailsconfirmed &&
          isenable) ||
        (isSelfie &&
          msgStepper_39 &&
          !nach_flag_status &&
          isEMandateCompleted &&
          isdetailsconfirmed &&
          isenable) ||
        (isdetailsconfirmed && isdetailsconfirmed && isenable)) &&      
        ((insurance_opted==false) && (!showTopupOffer))">
          <div class="fin-box">
            <div class="fin-box-header">
              <div class="fin-header-text">
                <h3 class="highlight">
                  Don't Miss Out on <br />
                  <span class="blue">FinProtect</span>
                  <div class="gold-tag-wrapper">
                    <span class="gold-tag">Gold</span>
                    <div class="gold-divider"></div>
                    <!-- Add this -->
      
                    <img
                      src="assets/images/starburst.png"
                      class="gold-star"
                    />
                  </div>
                </h3>
                <p class="fin-subtext">
                 For just ₹{{insurance_premium}} (that's ₹{{insurance_per_day}}/day), enjoy unlimited 24/7 medical assistance and receive a complementary 
                 benefit to secure your loan in case of accidental death or permanent disability.
                </p>
              </div>
              <div class="umbrella-wrapper">
                <img
                  src="assets/images/starburst.png"
                  class="starburst-img"
                />
                <img
                  src="assets/images/finprotect_main.png"
                  class="umbrella-img"
                />
              </div>
            </div>
          </div>
      
          <div class="feature-section">
            <div class="features-grid">
              <div class="feature-item">
                <img
                  src="assets/images/fin_1.png"
                  alt="Teleconsultation"
                />
                <p>
                  24*7 access to <br> Doctors via tele- <br>consultation
                </p>
              </div>
              <div class="feature-item">
                <img
                  src="assets/images/fin_2.png"
                  alt="Accident Coverage"
                />
                  <p> ₹{{GridAmount}} loan
                  <br> coverage in case of 
                  <br> accidental death
                 </p>
              </div>
              <div class="feature-item">
                <img src="assets/images/fin_3.png" alt="Dengue/Malaria" />
                <p>
                   ₹ 25000 coverage
                   <br>Vector-borne
                   <br>disease coverage for<br>
                    illnesses like dengue
                   <br>
                  & malaria
                </p>
              </div>
              <div class="feature-item">
                <img src="assets/images/fin_4.png" alt="ICU Charges"/>
                <p> Up to 100% loan,
                <br>coverage in case of 
                <br>permanent disability 
                </p>
              </div>
            </div>
          </div>         

        </li>
        <div class="cta-actions" *ngIf="
        ( (isEMandateCompleted &&
           msgStepper_10011 &&
           isdetailsconfirmed &&
           isenable) ||
         (iscommupdated &&
           !nach_flag_status &&
           isEMandateCompleted &&
           isdetailsconfirmed &&
           isenable) ||
         (isSelfie &&
           msgStepper_39 &&
           !nach_flag_status &&
           isEMandateCompleted &&
           isdetailsconfirmed &&
           isenable) ||
         (isdetailsconfirmed && isdetailsconfirmed && isenable)) &&
       ((insurance_opted==false) && (!showTopupOffer))">
        
          <button class="btn-skip" (click)="onSkipInsurance()" [hidden]="isSkipInsurance||isInsuranceAdded">Skip for now</button>
          <button class="btn-add" (click)="onInsuranceconfirm1()" [hidden]="isInsuranceAdded||isSkipInsurance">Add FinProtect Gold
            
          </button>
        </div>
        <div class="container_topup2" style="margin-bottom: 20px" *ngIf="isInsuranceAdded">
        <div class="inner__bottom" >
          <div class="inner__botton__content">
            <p>Your loan details.</p>
            <div class="inner__bottom_details">
              <p>Loan Amount</p>
              <p>₹ {{ GridAmount | inrFormat }}</p>
            </div>

            <div class="inner__bottom_details">
              <p>Loan Tenor</p>
              <p>{{ GridTenor }} months</p>
            </div>
            <div class="inner__bottom_details">
              <p>Interest Rate</p>
              <p>{{ GridRoi }} %</p>
            </div>
            <div class="inner__bottom_details">
              <p>EMI Amount</p>
              <p>₹{{ GridEmi | inrFormat }}p.m.</p>
            </div>
            <div class="inner__bottom_details">
              <p>Processing fee <span>(Incl. GST)</span></p>
              <div class="front-promo">
                <p>₹ {{ GridProcessingFee | inrFormat }}</p>
              </div>
            </div>
            <div class="inner__bottom_details">
              <p class="changecolor">'Finprotect Gold' Fee</p>
              <p>₹{{ insurance_premium | inrFormat }}</p>
            </div>
            <div class="inner__bottom_details">
             
              <p>
                <b>Amount to be Received in account.</b><br />
                <span
                  >Post deduction of processing fee and insurance
                  premium</span
                >
              </p>
              <p>₹ {{ netdisbusedamount | inrFormat }}</p>
            </div>
          </div>
        </div>

        </div>
        <div [ngStyle] ="{ 'margin-top': '10px' }" *ngIf="isInsuranceAdded">
       <button
          (click)="onInsuranceconfirm1()"
          [hidden]="isFingoldconfirmed"
         
        >
          Confirm Details
        </button>
        
          </div>
          <div class="timeLineMsg-right left" *ngIf="isFingoldconfirmed">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>FinProtect Gold added successfully..</p>
              </div>
            </div>
          </div> 
      
      <!-- INSURANCE NUDGE CARD  END--> 




        <li
          class="show-animation"
          style="margin-top: 70px"
          *ngIf="
            ((isEMandateCompleted &&
              msgStepper_10011 &&
              isdetailsconfirmed &&
              isenable) ||
            (iscommupdated &&
              !nach_flag_status &&
              isEMandateCompleted &&
              isdetailsconfirmed &&
              isenable) ||
            (isSelfie &&
              msgStepper_39 &&
              !nach_flag_status &&
              isEMandateCompleted &&
              isdetailsconfirmed &&
              isenable) ||
            (isdetailsconfirmed && isdetailsconfirmed && isenable))
            &&
             (isSkipInsurance)
          "
        >
          <div class="left-allign margin-top200" style="margin-left: -10px">
            <img
              src="assets/new-icons/afterTerms.png"
              class="status_img_height"
            />
          </div>
        </li>

        <li
          class="show-animation"
          *ngIf="
            ((isEMandateCompleted &&
              msgStepper_10011 &&
              isdetailsconfirmed &&
              isenable) ||
            (iscommupdated &&
              !nach_flag_status &&
              isEMandateCompleted &&
              isdetailsconfirmed &&
              isenable) ||
            (isSelfie &&
              msgStepper_39 &&
              !nach_flag_status &&
              isEMandateCompleted &&
              isdetailsconfirmed &&
              isenable) ||
            (isdetailsconfirmed && isdetailsconfirmed && isenable)) && (isSkipInsurance)"
        >
          <div class="content1">
            <b>Enter OTP</b><br />Please enter the OTP sent to {{ Mobile }} to
            accept the Loan
            <button
              type="button"
              data-toggle="modal"
              data-target="#exampleModal"
              class="linkbutton"
              (click)="kycModal(4)"
              [disabled]="isDisabled5 == true"
            >
              Terms and Conditions.
            </button>
          </div>
          <div class="otpcontainer kfs-otp-container" *ngIf="otp_input">
            <ng-otp-input
              #ngOtpInput
              (onInputChange)="KFS_otp_verify($event)"
              [config]="config1"
              [ngClass]="{ otpErrorClass: otperror }"
            ></ng-otp-input>
            <!-- <p style="display: flex";><span class="wrongOTP">Invalid OTP</span> <span style="text-align: right;">0:00 Sec</span></p>  -->
            <div class="error-container" [hidden]="kfsotpverified">
              <p class="otperror">{{ Errormessage }}</p>
              <p
                *ngIf="resend_OTP"
                (click)="KFS_otp_send()"
                style="cursor: pointer; color: #1066ad"
                [hidden]="kfsotpverified"
              >
                Resend OTP
              </p>
              <p *ngIf="!resend_OTP">{{ timeLeft }} sec</p>
            </div>
          </div>

          <button
            (click)="kycModal(5)"
            type="button"
            [hidden]="isDisabled4 == true"
            type="button"
            [ngClass]="{ disabledClass: isDisabled4 == true }"
          >
            Confirm
          </button>
          <div></div>

          <div class="custom-lds-model">
            <div
              class="modal fade"
              id="exampleModal"
              tabindex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div
                class="inner-loader z-1000 fixed trbl-0 vh-center bg-white-50 blur-2"
                style="height: 100%"
                *ngIf="Modelloader1"
              >
                <img src="assets/loading.gif" width="25" class="vh-center" />
              </div>
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <p class="modal-title" id="exampleModalLabel">
                      Loan Terms & Conditions
                    </p>
                    <button
                      type="button"
                      class="close"
                      #closemodal
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="cst-dynamic-kfs">
                      <div *ngFor="let item of response">
                        <div [innerHTML]="item"></div>
                      </div>
                    </div>

                    <!-- -----End-Loader-Section---- -->

                    <!-- --------------------------LDS-section---- -->
                    <!-- ------------Button-div -->
                    <div class="continue_bottom_btn">
                      <mat-card>
                        <div class="submit">
                          <!-- <div class="submit-inner">
                                        <mat-checkbox [disabled]="disablecheckbox" (change)="oncheckclick($event)">I
                                            agree to the Terms and Conditions</mat-checkbox>
                                            [ngClass]="{'disabledClass': disableldsaccept==true}"
                                    </div> -->
                          <div class="continue-btn button_div_common">
                            <button
                              class="click-btn pointer"
                              (click)="onldsAccept()"
                            >
                              <span class="button_div_common_text"
                                >Continue</span
                              ><span style="float: right" class="pd-right-0"
                                ><svg
                                  width="23"
                                  height="19"
                                  viewBox="0 0 23 19"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M22.7052 8.68674L16.4023 1.03344C15.8806 0.449655 15.0447 0.394072 14.4957 0.843451C13.9468 1.29283 13.8564 2.20104 14.3061 2.74996L18.7942 8.19471H1.84103C1.09521 8.19471 0.490356 8.79954 0.490356 9.54539C0.490356 10.2912 1.09518 10.8961 1.84103 10.8961H18.7942L14.3061 16.3408C13.8567 16.8894 13.9578 17.7851 14.4957 18.2473C15.0506 18.724 15.9529 18.6063 16.4023 18.0573L22.7052 10.404C23.1156 9.82716 23.0805 9.24558 22.7052 8.6875V8.68674Z"
                                    fill="white"
                                  />
                                </svg>
                              </span>
                            </button>
                          </div>
                        </div>
                      </mat-card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>

        <!--X-sell Non insurance -->
        <li
          class="show-animation"
          *ngIf="
            (isEMandateCompleted &&
              msgStepper_10011 &&
              !showinsurance &&
              !showTopupOffer &&
              isenable) ||
            (iscommupdated &&
              !nach_flag_status &&
              isEMandateCompleted &&
              !showinsurance &&
              !showTopupOffer &&
              isenable) ||
            (isSelfie &&
              msgStepper_39 &&
              !nach_flag_status &&
              isEMandateCompleted &&
              !showinsurance &&
              !showTopupOffer &&
              isenable)
          "
        >
          <div class="left-allign margin-top96" style="margin-left: -10px">
            <img
              src="assets/new-icons/afterTerms.png"
              class="status_img_height"
            />
          </div>
        </li>

        <li
          class="show-animation"
          *ngIf="
            (isEMandateCompleted &&
              msgStepper_10011 &&
              !showinsurance &&
              !showTopupOffer &&
              isenable) ||
            (iscommupdated &&
              !nach_flag_status &&
              isEMandateCompleted &&
              !showinsurance &&
              !showTopupOffer &&
              isenable) ||
            (isSelfie &&
              msgStepper_39 &&
              !nach_flag_status &&
              isEMandateCompleted &&
              !showinsurance &&
              !showTopupOffer &&
              isenable)
          "
        >
          <div>
            <div class="content1">
              <b>Enter OTP</b><br />Please enter the OTP sent to {{ Mobile }} to
              accept the Loan
              <button
                type="button"
                data-toggle="modal"
                data-target="#exampleModal"
                class="linkbutton"
                (click)="kycModal(4)"
                [disabled]="isDisabled5 == true"
              >
                Terms and Conditions.
              </button>
            </div>
            <div class="otpcontainer kfs-otp-container" *ngIf="otp_input">
              <ng-otp-input
                #ngOtpInput
                (onInputChange)="KFS_otp_verify($event)"
                [config]="config1"
                [ngClass]="{ otpErrorClass: otperror }"
              ></ng-otp-input>
              <!-- <p style="display: flex";><span class="wrongOTP">Invalid OTP</span> <span style="text-align: right;">0:00 Sec</span></p>  -->
              <div class="error-container" [hidden]="kfsotpverified">
                <p class="otperror">{{ Errormessage }}</p>
                <p
                  *ngIf="resend_OTP"
                  (click)="KFS_otp_send()"
                  style="cursor: pointer; color: #1066ad"
                  [hidden]="kfsotpverified"
                >
                  Resend OTP
                </p>
                <p *ngIf="!resend_OTP">{{ timeLeft }} sec</p>
              </div>
            </div>
            <button
              (click)="kycModal(5)"
              type="button"
              [disabled]="isDisabled4 == true"
              type="button"
              [ngClass]="{ disabledClass: isDisabled4 == true }"
            >
              Confirm
            </button>
            <div></div>
          </div>
          <div class="custom-lds-model">
            <div
              class="modal fade"
              id="exampleModal"
              tabindex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div
                class="inner-loader z-1000 fixed trbl-0 vh-center bg-white-50 blur-2"
                style="height: 100%"
                *ngIf="Modelloader1"
              >
                <img src="assets/loading.gif" width="25" class="vh-center" />
              </div>
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <p class="modal-title" id="exampleModalLabel">
                      Loan Terms & Conditions
                    </p>
                    <button
                      type="button"
                      class="close"
                      #closemodal
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="cst-dynamic-kfs">
                      <div *ngFor="let item of response">
                        <div [innerHTML]="item"></div>
                      </div>
                    </div>
                    <!-- -----End-Loader-Section---- -->

                    <!-- --------------------------LDS-section---- -->
                    <!-- ------------Button-div -->
                    <div class="continue_bottom_btn">
                      <mat-card>
                        <div class="submit">
                          <!-- <div class="submit-inner">
                                        <mat-checkbox [disabled]="disablecheckbox" (change)="oncheckclick($event)">I
                                            agree to the Terms and Conditions</mat-checkbox>
                                    </div> -->
                          <!-- [ngClass]="{'disabledClass': disableldsaccept==true}" -->
                          <div class="continue-btn button_div_common">
                            <button
                              class="click-btn pointer"
                              (click)="onldsAccept()"
                            >
                              <span class="button_div_common_text"
                                >Continue</span
                              ><span style="float: right" class="pd-right-0"
                                ><svg
                                  width="23"
                                  height="19"
                                  viewBox="0 0 23 19"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M22.7052 8.68674L16.4023 1.03344C15.8806 0.449655 15.0447 0.394072 14.4957 0.843451C13.9468 1.29283 13.8564 2.20104 14.3061 2.74996L18.7942 8.19471H1.84103C1.09521 8.19471 0.490356 8.79954 0.490356 9.54539C0.490356 10.2912 1.09518 10.8961 1.84103 10.8961H18.7942L14.3061 16.3408C13.8567 16.8894 13.9578 17.7851 14.4957 18.2473C15.0506 18.724 15.9529 18.6063 16.4023 18.0573L22.7052 10.404C23.1156 9.82716 23.0805 9.24558 22.7052 8.6875V8.68674Z"
                                    fill="white"
                                  />
                                </svg>
                              </span>
                            </button>
                          </div>
                        </div>
                      </mat-card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>

        <div class="inner-loader" *ngIf="loader1">
          <img src="assets/loading.gif" width="25" class="vh-center" />
        </div>
        <div
          class="show-animation"
          *ngIf="
            (isEMandateCompleted && msgStepper_10031) ||
            (iscommupdated && showLDS && !nach_flag_status)
          "
          [hidden]="hideldsloader"
        >
          <div class="stepper-hr2"></div>

          <div class="inner-loader1 vh-center" *ngIf="ldsloader">
            <img src="assets/loading.gif" width="25" />
          </div>
        </div>
        <div
          class="Loader-gif vh-center"
          *ngIf="!iscommupdated && ishiddencom && isKYCSuccess"
        >
          <img src="assets/loading.gif" width="25" />
        </div>

        <li
          class="show-animation"
          *ngIf="isEMandateCompleted && msgStepper_904 && showLoader"
        >
          <div class="timeLineMsg">
            <div class="content">
              <p class="">
                Processing please wait...<br /><br />
                <img
                  src="assets/loading.gif"
                  width="25"
                  style="text-align: center !important"
                  class="Loader-gif vh-center"
                />
              </p>
            </div>
          </div>
        </li>
        <li
          *ngIf="
            (isLDSCompleted && msgStepper_1004 && isenable) ||
            (isLDSCompleted1 && msgStepper_10041 && isenable)
          "
        >
          <div class="timeLineMsg-right left">
            <div class="alt-content1">
              <div class="happy-sec">
                <p>Loan aggreement accepted.</p>
              </div>
            </div>
          </div>
        </li>

        <!-- LDS SUCCESS -->
        <li
        class="show-animation"
        *ngIf="
          (isLDSCompleted && msgStepper_1005 && isenable) ||
          (isLDSCompleted1 && msgStepper_10051 && isenable)
        "
      >
        <div style="margin-top: 80px !important">
          <img
            src="assets/images/winnerCup1.png"
            height="130px"
            style="margin-bottom: 5px"
          />
        </div>
      </li>

      <li
      class="show-animation"
      *ngIf="
        (isLDSCompleted && msgStepper_1006 && isenable) ||
        (isLDSCompleted1 && msgStepper_10061 && isenable)
      "
    >
      <div>
        <!-- <div class="stepper-hr1"></div> -->
        <div class="content">
          <p>Congratulations! <br>  Your loan application is complete.</p>       
        </div>
        <!-- <div class="content">
          <p>
            DMI Finance's customer care executive may call you from
            080-3773-8565 to verify a few details. Upon successful
            verification, your pre-approved Personal Loan will be
            disbursed to your registered bank account.
          </p>
        </div> -->
        <div>
          <div class="content" *ngIf="stp_flag=='CPV Required'">
            <p >
              Our representative will visit you within the next 3 working
              days for current address verification. 
              Once successfully verified, your loan will be disbursed within 2 working days, 
              subject to credit approval.
            </p> 
            </div>

            <div class="content" *ngIf="(stp_flag=='STP') || (stp_flag=='NSTP' )|| (stp_flag==undefined)|| (stp_flag==Null)">
              <p>
              We are processing your application, 
              and your loan will be disbursed within 3 working days, 
              subject to credit approval.
              </p> 
              </div>
              <div class="content"> 
                <p>
                  You can download the DMI Finance APP from the link below to manage your loan seamlessly,
                  to get a free Credit report or pay your Utility and Mobile Bills with ease.
                </p> 
                </div>
                <button mat-button (click)="onSubmitGetDmiFinanceApp()">
                  Get DMI Finance APP
                </button>
        </div>
      </div>
    </li>
    <li class="show-animation"
      *ngIf="isLDSCompleted && msgStepper_1101"
    ></li>
      
      </ul>
    </div> 
   </div>
</div>
<!-- Web Enage -->

<head>
  <script id="_webengage_script_tag" type="text/javascript">
    var webengage;
    !(function (w, e, b, n, g) {
      function o(e, t) {
        e[t[t.length - 1]] = function () {
          r.__queue.push([t.join("."), arguments]);
        };
      }
      var i,
        s,
        r = w[b],
        z = " ",
        l = "init options track screen onReady".split(z),
        a =
          "webPersonalization feedback survey notification notificationInbox".split(
            z
          ),
        c = "options render clear abort".split(z),
        p = "Prepare Render Open Close Submit Complete View Click".split(z),
        u = "identify login logout setAttribute".split(z);
      if (!r || !r.__v) {
        for (
          w[b] = r = { __queue: [], __v: "6.0", user: {} }, i = 0;
          i < l.length;
          i++
        )
          o(r, [l[i]]);
        for (i = 0; i < a.length; i++) {
          for (r[a[i]] = {}, s = 0; s < c.length; s++) o(r[a[i]], [a[i], c[s]]);
          for (s = 0; s < p.length; s++) o(r[a[i]], [a[i], "on" + p[s]]);
        }
        for (i = 0; i < u.length; i++) o(r.user, ["user", u[i]]);
        setTimeout(function () {
          var f = e.createElement("script"),
            d = e.getElementById("_webengage_script_tag");
          (f.type = "text/javascript"),
            (f.async = !0),
            (f.src =
              ("https:" == e.location.protocol
                ? "https://widgets.in.webengage.com"
                : "http://widgets.in.webengage.com") +
              "/js/webengage-min-v-6.0.js"),
            d.parentNode.insertBefore(f, d);
        });
      }
    })(window, document, "webengage");
    // uat
    //  webengage.init("in~826172d4");
    // Production
     webengage.init("in~58adcc15");
  </script>
</head>
